import React, { useEffect, useMemo, useRef, useState } from "react";
import Swal from "sweetalert2";
import "./CSS/Entregas.css";
import { dominio } from "../../../routes_backend/routes.jsx";
import logo2 from "../../../assets/img/ImpresionBodega.png";

const API_URL_ORDENES_VENTA = `${dominio}/SGIM_OrdenVentaFilterProveedores`;
const API_URL_DETALLE_ORDEN_VENTA = `${dominio}/SGIM_OrdenVenta`;
const API_URL_CREAR_ENTREGA = `${dominio}/SGIM_Entrega`;
const API_URL_ENTREGA_STOCK_CANCELACION = `${dominio}/SGIM_EntregasFilterDocumentos`;
const API_URL_CANCELAR_ENTREGA_STOCK = (docEntry) =>
  `${dominio}/SGIM_Entrega/${docEntry}/cancel`;
const API_URL_DETALLE_ENTREGA = `${dominio}/SGIM_Entrega`;
const API_URL_STOCK_ORIGEN_ENTREGAS = `${dominio}/SGIM_StockOrigenTransfereciasimport`;
const API_URL_TAGS = `${dominio}/getTags`;

const API_KEY = "b4ed47a3-b372-49df-a200-2e68d5f7a454";

const LOGO_TICKET = logo2;
const DEFAULT_IVA_PERCENT = 12;

const ALMACENES_DESTINO_ENTREGA = [
  "AFM001",
  "BCP09",
  "BTA01",
  "BTB01",
  "BTC01",
  "BTE01",
  "BTF01",
  "BTG01",
  "BTH01",
  "BTM01",
  "BTP01",
  "BTR01",
  "BTX01",
];

const obtenerOpcionesAlmacenDestino = (almacenActual) => {
  const actual = String(almacenActual || "").trim();

  if (actual && !ALMACENES_DESTINO_ENTREGA.includes(actual)) {
    return [actual, ...ALMACENES_DESTINO_ENTREGA];
  }

  return ALMACENES_DESTINO_ENTREGA;
};

const formatDateForInput = (dateValue) => {
  if (!dateValue) return "";

  const rawValue = String(dateValue).trim();
  if (!rawValue) return "";

  // Si ya viene en formato compatible con input type="date".
  const isoMatch = rawValue.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    return `${isoMatch[1]}-${isoMatch[2]}-${isoMatch[3]}`;
  }

  // Soporta fechas tipo DD/MM/YYYY o DD-MM-YYYY.
  const localMatch = rawValue.match(/^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})$/);
  if (localMatch) {
    const day = localMatch[1].padStart(2, "0");
    const month = localMatch[2].padStart(2, "0");
    const year = localMatch[3];
    return `${year}-${month}-${day}`;
  }

  const date = new Date(rawValue);
  if (Number.isNaN(date.getTime())) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const obtenerFechaDocumento = (...valores) => {
  const valor = valores.find(
    (item) => item !== undefined && item !== null && String(item).trim() !== ""
  );

  return formatDateForInput(valor);
};

const obtenerFechaVencimiento = (detalle) => {
  return obtenerFechaDocumento(
    detalle?.DocDueDate,
    detalle?.DueDate,
    detalle?.DocDue,
    detalle?.FechaVencimiento,
    detalle?.FechaDeVencimiento,
    detalle?.FecVencimiento,
    detalle?.RequiredDate,
    detalle?.RequriedDate,
    detalle?.ReqDate,
    detalle?.U_FechaVencimiento
  );
};

const extraerDocNumCreadoRespuesta = (message) => {
  const texto = String(message || "");
  const match = texto.match(/DocNum\s+(\d+)/i) || texto.match(/No\.?\s*(\d+)/i);
  return match ? match[1] : "";
};

const formatDateDisplay = (dateValue) => {
  if (!dateValue) return "";

  const rawValue = String(dateValue).trim();
  if (!rawValue) return "";

  // Evita desfase por zona horaria cuando viene como YYYY-MM-DD.
  // new Date("2026-04-30") se interpreta como UTC y en Guatemala puede mostrar 29/04/2026.
  const isoMatch = rawValue.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    const [, year, month, day] = isoMatch;
    return `${day}/${month}/${year}`;
  }

  const localMatch = rawValue.match(/^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})$/);
  if (localMatch) {
    const day = localMatch[1].padStart(2, "0");
    const month = localMatch[2].padStart(2, "0");
    const year = localMatch[3];
    return `${day}/${month}/${year}`;
  }

  const date = new Date(rawValue);
  if (Number.isNaN(date.getTime())) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${day}/${month}/${year}`;
};

const escapeHtml = (text) => {
  return String(text ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
};

const round2 = (value) =>
  Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;

const round4 = (value) =>
  Math.round((Number(value || 0) + Number.EPSILON) * 10000) / 10000;

const formatMoney2 = (value) =>
  round2(value).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const formatMoney4 = (value) =>
  round4(value).toLocaleString("en-US", {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  });

const sanitizeDecimalInput = (value) => {
  if (value == null) return "";
  let normalized = String(value).replaceAll(",", "").replace(/[^0-9.]/g, "");

  const firstDotIndex = normalized.indexOf(".");
  if (firstDotIndex !== -1) {
    normalized =
      normalized.slice(0, firstDotIndex + 1) +
      normalized.slice(firstDotIndex + 1).replaceAll(".", "");
  }

  return normalized;
};

const parseDecimal = (value) => {
  if (value == null) return 0;
  const normalized = String(value).replaceAll(",", "").trim();
  if (!normalized || normalized === ".") return 0;
  const parsed = Number(normalized);
  return Number.isNaN(parsed) ? 0 : parsed;
};

const getEditableDecimalValue = (linea, field) => {
  const inputField = `${field}Input`;

  if (linea?.[inputField] !== undefined && linea?.[inputField] !== null) {
    return String(linea[inputField]);
  }

  const value = linea?.[field];

  if (value === undefined || value === null) return "";

  return String(value);
};

const obtenerCantidadPendiente = (linea) => {
  if (linea?.OpenQuantity != null) return Number(linea.OpenQuantity);
  if (linea?.RemainingOpenQuantity != null) return Number(linea.RemainingOpenQuantity);
  if (linea?.Quantity != null) return Number(linea.Quantity);
  return 0;
};

const lineaEstaCerrada = (linea) => {
  return Number(obtenerCantidadPendiente(linea)) <= 0;
};

const obtenerPorcentajeIVA = (linea) => {
  const iva =
    linea?.VatPercent ??
    linea?.VatPrcnt ??
    linea?.TaxPercent ??
    linea?.U_TaxPercent ??
    DEFAULT_IVA_PERCENT;

  const parsed = Number(iva);
  return Number.isNaN(parsed) ? DEFAULT_IVA_PERCENT : parsed;
};

const obtenerFactorIVA = (linea) => {
  return 1 + obtenerPorcentajeIVA(linea) / 100;
};

const enriquecerLinea = (linea) => {
  const quantity = Number(linea.Quantity || 0);
  const precioInfo = round4(Number(linea.PrecioInfo || 0));
  const factorIVA = obtenerFactorIVA(linea);

  let precioConIVA = Number(linea.PrecioConIVA || 0);
  if (!precioConIVA) {
    precioConIVA = round4(precioInfo * factorIVA);
  }

  return {
    ...linea,
    Quantity: quantity,
    PrecioInfo: precioInfo,
    PrecioConIVA: round4(precioConIVA),
    VatPercent: obtenerPorcentajeIVA(linea),
    WarehouseCode: obtenerAlmacenDestino(linea),
    FromWarehouseCode: obtenerAlmacenOrigen(linea),
  };
};

const recalcularLineasConIva = (lines = []) => {
  return lines.map((linea) => {
    const qty = Number(linea.Quantity || 0);
    const precioInfo = round4(Number(linea.PrecioInfo || 0));
    const factorIVA = obtenerFactorIVA(linea);
    const precioConIVA = round4(precioInfo * factorIVA);

    return {
      ...linea,
      Quantity: qty,
      PrecioInfo: precioInfo,
      PrecioConIVA: precioConIVA,
      WarehouseCode: obtenerAlmacenDestino(linea),
      FromWarehouseCode: obtenerAlmacenOrigen(linea),
    };
  });
};

const calcularResumenDocumento = (lines = []) => {
  const lineas = recalcularLineasConIva(lines);

  const totalAntesDescuento = round2(
    lineas.reduce((acc, linea) => {
      return acc + Number(linea.Quantity || 0) * Number(linea.PrecioInfo || 0);
    }, 0)
  );

  const totalDocumento = round2(
    lineas.reduce((acc, linea) => {
      return acc + Number(linea.Quantity || 0) * Number(linea.PrecioConIVA || 0);
    }, 0)
  );

  const impuesto = round2(totalDocumento - totalAntesDescuento);

  return {
    lineas,
    totalAntesDescuento,
    impuesto,
    totalDocumento,
  };
};

const construirComentarioConUsuario = (nombreApellido, comentarioOriginal) => {
  const usuario = String(nombreApellido || "").trim();
  const comentario = String(comentarioOriginal || "").trim();

  if (!usuario) return comentario;
  if (!comentario) return usuario;

  if (comentario.startsWith(usuario)) return comentario;

  return `${usuario} - ${comentario}`;
};

const construirComentariosEntrega = ({ usuario, comments }) => {
  return construirComentarioConUsuario(usuario, comments);
};

const extraerComentarioBase = (textoCompleto, numAtCard, uFacNom) => {
  const prefijos = [];

  if (String(numAtCard || "").trim()) {
    prefijos.push(`${String(numAtCard).trim()}`);
  }

  if (String(uFacNom || "").trim()) {
    prefijos.push(`${String(uFacNom).trim()}`);
  }

  const prefijoCompleto = prefijos.join(", ");
  const texto = String(textoCompleto || "").trim();

  if (!prefijoCompleto) return texto;
  if (texto.startsWith(prefijoCompleto)) {
    return texto.slice(prefijoCompleto.length).replace(/^\s*,\s*/, "");
  }

  return texto;
};


const obtenerLineasDocumento = (detalle) => {
  if (!detalle) return [];

  if (Array.isArray(detalle)) return detalle;

  const posiblesLineas = [
    detalle.DocumentLines,
    detalle.DocumentLine,
    detalle.DocumentLinesDTO,
    detalle.StockTransferLines,
    detalle.StockTransferLine,
    detalle.TransferStockLines,
    detalle.Lines,
    detalle.Lineas,
    detalle.Detalle,
    detalle.Detalles,
    detalle.detalle,
    detalle.detalles,
    detalle.Items,
    detalle.rows,
    detalle.Rows,
    detalle.data?.DocumentLines,
    detalle.data?.DocumentLine,
    detalle.data?.StockTransferLines,
    detalle.data?.Lines,
    detalle.data?.Lineas,
    detalle.data?.Detalle,
    detalle.data?.Detalles,
    detalle.data?.rows,
    detalle.data?.Rows,
  ];

  const lineasDirectas = posiblesLineas.find((item) => Array.isArray(item));
  if (Array.isArray(lineasDirectas)) return lineasDirectas;

  const buscarArregloDeLineas = (obj, profundidad = 0, visitados = new Set()) => {
    if (!obj || typeof obj !== "object" || profundidad > 4 || visitados.has(obj)) {
      return [];
    }

    visitados.add(obj);

    for (const value of Object.values(obj)) {
      if (Array.isArray(value)) {
        const pareceDetalleLineas = value.some(
          (linea) =>
            linea &&
            typeof linea === "object" &&
            (linea.ItemCode != null ||
              linea.ItemDescription != null ||
              linea.Dscription != null ||
              linea.LineNum != null ||
              linea.Quantity != null ||
              linea.OpenQuantity != null ||
              linea.WhsCode != null ||
              linea.WarehouseCode != null)
        );

        if (pareceDetalleLineas) return value;
      }
    }

    for (const value of Object.values(obj)) {
      if (value && typeof value === "object" && !Array.isArray(value)) {
        const resultado = buscarArregloDeLineas(value, profundidad + 1, visitados);
        if (resultado.length > 0) return resultado;
      }
    }

    return [];
  };

  return buscarArregloDeLineas(detalle);
};

const normalizarDocumentoConLineas = (detalleOriginal) => {
  if (Array.isArray(detalleOriginal)) {
    const encabezado = detalleOriginal[0] || {};
    return {
      ...encabezado,
      DocumentLines: detalleOriginal,
    };
  }

  if (!detalleOriginal || typeof detalleOriginal !== "object") {
    return null;
  }

  const detalleData =
    detalleOriginal.data && !Array.isArray(detalleOriginal.data) && typeof detalleOriginal.data === "object"
      ? detalleOriginal.data
      : {};

  return {
    ...detalleOriginal,
    ...detalleData,
    DocumentLines: obtenerLineasDocumento(detalleOriginal),
  };
};

const obtenerTexto = (...valores) => {
  const valor = valores.find(
    (item) => item !== undefined && item !== null && String(item).trim() !== ""
  );

  return valor === undefined || valor === null ? "" : String(valor);
};

const obtenerCodigoArticulo = (linea) =>
  obtenerTexto(linea?.ItemCode, linea?.Item, linea?.Articulo, linea?.CodigoArticulo);

const obtenerDescripcionArticulo = (linea) =>
  obtenerTexto(
    linea?.ItemDescription,
    linea?.Dscription,
    linea?.Description,
    linea?.ItemName,
    linea?.Descripcion,
    linea?.DescripcionArticulo
  );

const obtenerAlmacenOrigen = (linea) =>
  obtenerTexto(
    linea?.FromWarehouseCode,
    linea?.FromWhsCod,
    linea?.FromWhsCode,
    linea?.Filler,
    linea?.FromWarehouse,
    linea?.AlmacenOrigen,
    linea?.WhsCodeOrigen,
    linea?.WarehouseCode,
    linea?.WhsCode
  );

const obtenerAlmacenDestino = (linea) =>
  obtenerTexto(
    linea?.WarehouseCode,
    linea?.WhsCode,
    linea?.ToWarehouseCode,
    linea?.ToWhsCode,
    linea?.ToWhsCod,
    linea?.AlmacenDestino,
    linea?.WhsCodeDestino
  );

const obtenerAlmacenTag = (tag) =>
  obtenerTexto(
    tag?.Almacen,
    tag?.almacen,
    tag?.WarehouseCode,
    tag?.WhsCode,
    tag?.Warehouse,
    tag?.Bodega,
    tag?.LocationWarehouse,
    tag?.location_warehouse
  );

const obtenerAlmacenLineaEscaneo = (linea) =>
  obtenerTexto(
    obtenerAlmacenOrigen(linea),
    obtenerAlmacenDestino(linea),
    linea?.Almacen,
    linea?.WarehouseCode,
    linea?.WhsCode
  );

const obtenerAlmacenReferenciaLinea = (linea) => {
  return normalizarCodigoRuta(
    obtenerTexto(
      obtenerAlmacenOrigen(linea),
      linea?.FromWarehouseCode,
      linea?.FromWhsCod,
      linea?.FromWhsCode,
      linea?.Almacen,
      linea?.WarehouseCode,
      linea?.WhsCode,
      obtenerAlmacenDestino(linea)
    )
  );
};

const obtenerStockAlmacenOrigen = (linea) => {
  const stock =
    linea?.StockO ??
    linea?.StockOrigen ??
    linea?.StockAlmacenOrigen ??
    linea?.Stock_Origen ??
    linea?.OnHandOrigen ??
    linea?.OnHandFromWarehouse ??
    linea?.OnHandFromWhs ??
    linea?.InStockOrigen ??
    linea?.AvailableOrigen ??
    linea?.AvailableQtyOrigen ??
    linea?.Stock ??
    linea?.OnHand ??
    linea?.InStock ??
    linea?.Disponible;

  if (stock === undefined || stock === null || String(stock).trim() === "") return "";

  const parsed = Number(stock);
  if (Number.isNaN(parsed)) return String(stock);

  return parsed.toLocaleString("es-GT", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};



const obtenerStockOrigenNumerico = (linea) => {
  const stock =
    linea?.StockO ??
    linea?.StockOrigen ??
    linea?.StockAlmacenOrigen ??
    linea?.Stock_Origen ??
    linea?.OnHandOrigen ??
    linea?.OnHandFromWarehouse ??
    linea?.OnHandFromWhs ??
    linea?.InStockOrigen ??
    linea?.AvailableOrigen ??
    linea?.AvailableQtyOrigen ??
    linea?.Stock ??
    linea?.OnHand ??
    linea?.InStock ??
    linea?.Disponible;

  const parsed = Number(stock);
  return Number.isNaN(parsed) ? 0 : parsed;
};

const fetchStockOrigenEntrega = async ({ itemCode, whsCode }) => {
  try {
    const item = String(itemCode || "").trim();
    const almacen = String(whsCode || "").trim();

    if (!item || !almacen) return 0;

    const url = `${API_URL_STOCK_ORIGEN_ENTREGAS}?ItemCode=${encodeURIComponent(item)}&WhsCode=${encodeURIComponent(almacen)}`;
    console.log(url);
    

    const res = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "API-Key": API_KEY,
      },
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok || data.answer !== "true") {
      return 0;
    }

    const stock = Array.isArray(data.data)
      ? data.data?.[0]?.StockOrigen
      : data?.data?.StockOrigen;

    const parsed = Number(stock || 0);
    return Number.isNaN(parsed) ? 0 : parsed;
  } catch (error) {
    console.error("Error obteniendo stock de almacén:", error);
    return 0;
  }
};

const normalizarItemCode = (value) => String(value || "").trim().toUpperCase();

const obtenerUbicacionLinea = (linea, tagsPorItemCode) => {
  const ubicacionDirecta = obtenerTexto(
    linea?.location_desc_tag,
    linea?.LocationDescTag,
    linea?.Ubicacion,
    linea?.UbicacionTag,
    linea?.Location
  );

  if (ubicacionDirecta) return ubicacionDirecta;

  const tagCorrecto = obtenerTagLinea(linea, tagsPorItemCode);

  return obtenerTexto(
    tagCorrecto?.location_desc_tag,
    tagCorrecto?.LocationDescTag,
    tagCorrecto?.Ubicacion,
    tagCorrecto?.UbicacionTag,
    tagCorrecto?.Location
  );
};


const normalizarCodigoRuta = (value) =>
  String(value ?? "")
    .trim()
    .replace(/\s+/g, "")
    .toUpperCase();

const obtenerLocationDescTag = (tag) =>
  obtenerTexto(
    tag?.location_desc_tag,
    tag?.LocationDescTag,
    tag?.Ubicacion,
    tag?.UbicacionTag,
    tag?.Location
  );

const obtenerNumberTag = (tag) =>
  obtenerTexto(
    tag?.number_tag,
    tag?.NumberTag,
    tag?.NumeroTag,
    tag?.numberTag,
    tag?.TagNumber,
    tag?.tag_number,
    tag?.CodigoBarra,
    tag?.CodigoBarras
  );

const obtenerTagLinea = (linea, tagsPorItemCode) => {
  const itemCode = normalizarItemCode(obtenerCodigoArticulo(linea));

  if (!itemCode || !tagsPorItemCode) return null;

  const tagsArticulo = tagsPorItemCode.get(itemCode);
  if (!tagsArticulo) return null;

  const listaTags = Array.isArray(tagsArticulo)
    ? tagsArticulo
    : [tagsArticulo];

  if (listaTags.length === 0) return null;

  const almacenLinea = obtenerAlmacenReferenciaLinea(linea);

  if (almacenLinea) {
    const tagMismoAlmacen = listaTags.find((tag) => {
      const almacenTag = normalizarCodigoRuta(obtenerAlmacenTag(tag));
      return almacenTag && almacenTag === almacenLinea;
    });

    if (tagMismoAlmacen) {
      return tagMismoAlmacen;
    }
  }

  // Si solo existe un tag para el artículo, se utiliza ese registro.
  if (listaTags.length === 1) {
    return listaTags[0];
  }

  // Si existen varios tags y ninguno coincide con el almacén de la línea,
  // no se selecciona arbitrariamente el primero.
  return null;
};

const obtenerNumberTagLinea = (linea, tagsPorItemCode) => {
  const numeroDirecto = obtenerNumberTag(linea);
  if (numeroDirecto) return numeroDirecto;

  const tag = obtenerTagLinea(linea, tagsPorItemCode);
  return obtenerNumberTag(tag);
};

const obtenerNumeroLineaBase = (linea, index) => {
  const lineNum = linea?.LineNum ?? linea?.BaseLine ?? linea?.LineNumber ?? index;
  const parsed = Number(lineNum);
  return Number.isNaN(parsed) ? index : parsed;
};


const construirLineaDesdeDetalle = (linea, index = 0, cerrarPorPendiente = false) => {
  const cantidadPendiente = obtenerCantidadPendiente(linea);
  const quantity = cerrarPorPendiente
    ? cantidadPendiente
    : Number(linea?.Quantity || linea?.OpenQuantity || linea?.OpenQty || 0);

  const precioInfo =
    linea?.PrecioInfo != null
      ? Number(linea.PrecioInfo)
      : linea?.Price != null
      ? Number(linea.Price)
      : linea?.UnitPrice != null
      ? Number(linea.UnitPrice)
      : linea?.PriceBefDi != null
      ? Number(linea.PriceBefDi)
      : 0;

  const factorIVA = obtenerFactorIVA(linea);
  const numeroLineaOriginal = obtenerNumeroLineaBase(linea, index);

  return enriquecerLinea({
    ...linea,
    // Conserva la línea original de SAP, incluso si existen artículos repetidos.
    LineNum: numeroLineaOriginal,
    BaseLine: numeroLineaOriginal,
    // Identificador estable para eliminar únicamente la fila seleccionada.
    ClientLineId:
      linea?.ClientLineId ||
      `${numeroLineaOriginal}-${index}-${obtenerCodigoArticulo(linea)}`,
    ItemCode: obtenerCodigoArticulo(linea),
    ItemDescription: obtenerDescripcionArticulo(linea),
    OpenQuantity: cantidadPendiente,
    Quantity: quantity,
    PrecioInfo: precioInfo,
    PrecioConIVA:
      linea?.PrecioConIVA != null
        ? Number(linea.PrecioConIVA)
        : linea?.PriceAfterVAT != null
        ? Number(linea.PriceAfterVAT)
        : round4(precioInfo * factorIVA),
    IsClosedLine: cerrarPorPendiente ? cantidadPendiente <= 0 : false,
    WarehouseCode: obtenerAlmacenDestino(linea),
    FromWarehouseCode: obtenerAlmacenOrigen(linea),
    StockO: obtenerStockAlmacenOrigen(linea),
  });
};


const enriquecerLineasConStockOrigen = async (lines = []) => {
  return Promise.all(
    lines.map(async (linea) => {
      const stockActual = obtenerStockOrigenNumerico(linea);

      if (stockActual > 0) {
        return {
          ...linea,
          StockO: stockActual,
          StockOrigen: stockActual,
        };
      }

      const stockOrigen = await fetchStockOrigenEntrega({
        itemCode: obtenerCodigoArticulo(linea),
        whsCode: obtenerAlmacenOrigen(linea),
      });

      return {
        ...linea,
        StockO: stockOrigen,
        StockOrigen: stockOrigen,
      };
    })
  );
};

const generarHTMLTermicoEntrega = ({
  logoUrl,
  docNum,
  formData,
  lineasImpresas,
  copyLabel = "ENTREGA",
}) => {
  const filas = lineasImpresas
    .map((linea) => {
      const codigo = obtenerCodigoArticulo(linea);
      const descripcion = obtenerDescripcionArticulo(linea);
      const almacenOrigen = obtenerAlmacenOrigen(linea);
      const ubicacion = obtenerUbicacionLinea(linea);
      const stockOrigen = obtenerStockAlmacenOrigen(linea);
      const cantidad = Number(linea.Quantity || 0).toLocaleString("es-GT", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      return `
        <div class="line-row">
          <div class="cell codigo">${escapeHtml(codigo)}</div>
          <div class="cell descripcion">${escapeHtml(descripcion)}</div>
          <div class="cell almacen-origen">${escapeHtml(almacenOrigen)}</div>
          <div class="cell ubicacion">${escapeHtml(ubicacion)}</div>
          <div class="cell stock-origen">${escapeHtml(stockOrigen)}</div>
          <div class="cell cantidad">${escapeHtml(cantidad)}</div>
        </div>
      `;
    })
    .join("");

  const fechaDocumento = formatDateDisplay(formData.DocDate || formData.TaxDate);
  const comentarios = formData.Comments || "";

  return `
    <!DOCTYPE html>
    <html lang="es">
      <head>
        <meta charset="UTF-8" />
        <title>Entrega</title>
        <style>
          @page {
            size: 80mm auto;
            margin: 0;
          }

          html,
          body {
            width: 80mm;
            margin: 0;
            padding: 0;
            font-family: Arial, Helvetica, sans-serif;
            color: #000;
            background: #fff;
          }

          * {
            box-sizing: border-box;
          }

          .print-wrapper {
            width: 80mm;
            margin: 0 auto;
            padding: 0;
          }

          .ticket {
            width: 80mm;
            padding: 0.5mm 2.5mm 1mm 2.5mm;
          }

          .logo-wrap {
            text-align: center;
            margin-bottom: 1mm;
          }

          .logo {
            max-width: 48mm;
            max-height: 18mm;
            object-fit: contain;
          }

          .title {
            text-align: center;
            font-size: 18px;
            font-weight: 700;
            margin-top: 0.3mm;
            line-height: 1.05;
          }

          .docno {
            text-align: center;
            font-size: 16px;
            margin-bottom: 2mm;
            line-height: 1.05;
          }

          .block {
            font-size: 12px;
            line-height: 1.3;
            margin-bottom: 1.5mm;
          }

          .centered {
            text-align: center;
          }

          .copy-label {
            text-align: center;
            font-size: 20px;
            font-weight: 700;
            margin: 0.5mm 0 0.5mm 0;
            line-height: 1;
          }

          .lines-section {
            width: 100%;
            margin-top: 0;
          }

          .line-header,
          .line-row {
            display: grid;
            grid-template-columns: 20% 24% 12% 18% 12% 14%;
            column-gap: 0;
            width: 100%;
          }

          .line-header {
            border-bottom: 1px dashed #000;
            margin-bottom: 0.4mm;
          }

          .line-header div {
            font-size: 8px;
            font-weight: 700;
            line-height: 1.05;
            padding: 0.4mm 0.25mm;
            word-break: break-word;
          }

          .line-row {
            margin: 0;
            padding: 0;
            page-break-inside: avoid;
            break-inside: avoid;
          }

          .cell {
            font-size: 8px;
            line-height: 1.08;
            padding: 0.35mm 0.25mm;
            word-break: break-word;
            vertical-align: top;
          }

          .codigo {
            word-break: break-all;
          }

          .descripcion,
          .ubicacion {
            word-break: break-word;
          }

          .almacen-origen,
          .stock-origen {
            word-break: break-word;
          }

          .cantidad {
            text-align: right;
            white-space: nowrap;
          }

          .comments {
            margin-top: 2mm;
            font-size: 11px;
            line-height: 1.25;
            font-weight: 700;
            word-break: break-word;
          }

          .signature {
            margin-top: 12mm;
            font-size: 12px;
          }

          .footer {
            margin-top: 0.8mm;
            font-size: 9px;
            text-align: center;
            line-height: 1.1;
          }

          @media print {
            html,
            body {
              width: 80mm;
              margin: 0;
              padding: 0;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
          }
        </style>
      </head>
      <body>
        <div class="print-wrapper">
          <div class="ticket">
            <div class="logo-wrap">
              ${logoUrl ? `<img src="${logoUrl}" alt="Logo" class="logo" />` : ""}
            </div>

            <div class="copy-label">${escapeHtml(copyLabel)}</div>
            <div class="docno">No ${escapeHtml(docNum || "")}</div>

            <div class="block centered">
              <div><strong>Fecha:</strong> ${escapeHtml(fechaDocumento)}</div>
            </div>

            <div class="title">Entrega</div>

            <div class="lines-section">
              <div class="line-header">
                <div>Código</div>
                <div>Descripción</div>
                <div>Almacén</div>
                <div>Ubicación</div>
                <div>Stock</div>
                <div style="text-align:right;">Cant.</div>
              </div>
              ${filas}
            </div>

            <div class="comments">
              <strong>Comentarios:</strong> <strong>${escapeHtml(comentarios)}</strong>
            </div>

            <div class="signature">Vo Bo._______________________________</div>

            <div class="footer">
              Fecha y hora de impresión ${new Date().toLocaleString("es-GT")}
            </div>
          </div>
        </div>

        <script>
          window.onload = function () {
            setTimeout(() => {
              window.focus();
              window.print();
            }, 350);
          };

          window.onafterprint = function () {
            setTimeout(() => window.close(), 300);
          };
        </script>
      </body>
    </html>
  `;
};

const imprimirUnaCopiaTermicaEntrega = ({
  logoUrl,
  docNum,
  formData,
  copyLabel = "ENTREGA",
}) => {
  return new Promise((resolve, reject) => {
    const lineasImpresas = (formData.DocumentLines || []).filter(
      (linea) => Number(linea.Quantity || 0) > 0
    );

    const html = generarHTMLTermicoEntrega({
      logoUrl,
      docNum,
      formData,
      lineasImpresas,
      copyLabel,
    });

    const printWindow = window.open("", "_blank", "width=420,height=900");

    if (!printWindow) {
      reject(new Error("El navegador bloqueó la ventana de impresión."));
      return;
    }

    let finalizado = false;

    const terminar = () => {
      if (finalizado) return;
      finalizado = true;
      resolve();
    };

    printWindow.onafterprint = () => {
      setTimeout(terminar, 300);
    };

    const pollClosed = setInterval(() => {
      if (printWindow.closed) {
        clearInterval(pollClosed);
        terminar();
      }
    }, 400);

    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
  });
};

const swalBase = {
  customClass: {
    container: "swal-container-front",
    popup: "swal-front",
  },
};

/**
 * Browser Print no interpreta HTML.
 * Para Zebra móvil se envía CPCL como texto crudo.
 * Para computadora/navegador se mantiene el HTML original con window.print().
 */
const limpiarTextoCpcl = (value, maxLength = 999) => {
  return String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^\x20-\x7E]/g, "")
    .replace(/[\\"]/g, "")
    .replace(/[\r\n\t]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .substring(0, maxLength);
};

const partirTextoCpcl = (value, maxChars = 28, maxLines = 2) => {
  const texto = limpiarTextoCpcl(value);
  if (!texto) return [""];

  const palabras = texto.split(" ");
  const lineas = [];
  let actual = "";

  palabras.forEach((palabra) => {
    const intento = actual ? `${actual} ${palabra}` : palabra;

    if (intento.length <= maxChars) {
      actual = intento;
      return;
    }

    if (actual) lineas.push(actual);

    if (palabra.length > maxChars) {
      lineas.push(palabra.substring(0, maxChars));
      actual = palabra.substring(maxChars);
    } else {
      actual = palabra;
    }
  });

  if (actual) lineas.push(actual);

  return lineas.slice(0, maxLines);
};

const cpclText = (x, y, text, font = "0", size = "0") => {
  return `TEXT ${font} ${size} ${x} ${y} ${limpiarTextoCpcl(text)}\n`;
};

const generarCPCLTermicoEntrega = ({
  docNum,
  formData,
  lineasImpresas,
  copyLabel = "ENTREGA",
}) => {
  const fechaDocumento = formatDateDisplay(formData.DocDate || formData.TaxDate);
  const comentarios = formData.Comments || formData.CommentsBase || "";

  let y = 8;
  let body = "";

  const leftX = 18;
  const rightX = 558;
  const codeX = 18;
  const descX = 106;
  const qtyX = 242;
  const stockX = 286;
  const ubicX = 340;
  const origenX = 482;

  const NORMAL_FONT = "0";
  const NORMAL_SIZE = "0";

  const addNormalText = (x, yPos, texto, maxLength = 999) => {
    body += "SETMAG 1 2\n";
    body += cpclText(
      x,
      yPos,
      limpiarTextoCpcl(texto, maxLength),
      NORMAL_FONT,
      NORMAL_SIZE
    );
    body += "SETMAG 1 1\n";
  };

  const addTableText = (x, yPos, texto, maxLength = 999) => {
    body += cpclText(
      x,
      yPos,
      limpiarTextoCpcl(texto, maxLength),
      NORMAL_FONT,
      NORMAL_SIZE
    );
  };

  const addMacizoTitulo = () => {
    body += "CENTER\n";
    body += "SETMAG 2 2\n";
    body += cpclText(0, y, "MACIZO", "4", "0");
    body += cpclText(1, y, "MACIZO", "4", "0");
    body += cpclText(0, y + 1, "MACIZO", "4", "0");
    body += cpclText(1, y + 1, "MACIZO", "4", "0");
    body += "SETMAG 1 1\n";
    y += 105;
  };

  const addCenter = (
    texto,
    font = "0",
    size = "0",
    lineHeight = 20,
    maxLength = 42,
    usarNormalGrande = true
  ) => {
    body += "CENTER\n";
    if (usarNormalGrande && font === "0" && size === "0") {
      body += "SETMAG 1 2\n";
      body += cpclText(0, y, limpiarTextoCpcl(texto, maxLength), font, size);
      body += "SETMAG 1 1\n";
    } else {
      body += cpclText(0, y, limpiarTextoCpcl(texto, maxLength), font, size);
    }
    y += lineHeight;
  };

  const addWrappedLeft = (x, texto, maxChars = 42, maxLines = 2, lineHeight = 24) => {
    body += "LEFT\n";
    partirTextoCpcl(texto, maxChars, maxLines).forEach((linea) => {
      addNormalText(x, y, linea);
      y += lineHeight;
    });
  };

  addMacizoTitulo();
  addCenter(copyLabel, "4", "0", 50, 20, false);
  addCenter(`No ${docNum || ""}`, "0", "0", 28, 28);
  addCenter(`Fecha: ${fechaDocumento}`, "0", "0", 26, 42);

  y += 4;
  addCenter("Entrega", "4", "0", 54, 32, false);

  body += "LEFT\n";
  addTableText(codeX, y, "Codigo", 10);
  addTableText(descX, y, "Descripcion", 16);
  addTableText(qtyX, y, "Cant.", 6);
  addTableText(stockX, y, "Stock", 8);
  addTableText(ubicX, y, "Ubic:", 18);
  addTableText(origenX, y, "Orig.:", 7);
  y += 18;

  body += `LINE ${leftX} ${y} ${rightX} ${y} 1\n`;
  y += 10;

  lineasImpresas.forEach((linea) => {
    const codigo = limpiarTextoCpcl(obtenerCodigoArticulo(linea), 10);
    const descripcionLineas = partirTextoCpcl(obtenerDescripcionArticulo(linea), 16, 4);
    const almacenOrigen = limpiarTextoCpcl(obtenerAlmacenOrigen(linea) || "-", 5);
    const stockOrigen = limpiarTextoCpcl(obtenerStockAlmacenOrigen(linea) || "-", 8);
    const ubicacion = limpiarTextoCpcl(obtenerUbicacionLinea(linea) || "-", 18);
    const cantidad = limpiarTextoCpcl(
      Number(linea.Quantity || 0).toLocaleString("es-GT", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      6
    );

    addTableText(codeX, y, codigo, 10);
    addTableText(descX, y, descripcionLineas[0] || "", 16);
    addTableText(qtyX, y, cantidad, 6);
    addTableText(stockX, y, stockOrigen, 8);
    addTableText(ubicX, y, ubicacion, 18);
    addTableText(origenX, y, almacenOrigen, 5);
    y += 18;

    descripcionLineas.slice(1).forEach((descripcionExtra) => {
      addTableText(descX, y, descripcionExtra, 16);
      y += 18;
    });

    y += 4;
  });

  y += 8;
  body += "LEFT\n";
  addNormalText(leftX, y, "Comentarios:");
  y += 30;

  partirTextoCpcl(comentarios, 54, 3).forEach((linea) => {
    addNormalText(leftX, y, linea);
    y += 26;
  });

  y += 80;
  addNormalText(leftX, y, "Vo Bo.______________________________________________");
  y += 34;

  body += "CENTER\n";
  addNormalText(0, y, `Fecha y hora de impresion ${new Date().toLocaleString("es-GT")}`);
  y += 34;

  const MARGEN_INFERIOR_CPCL = 80;
  const altura = Math.max(y + MARGEN_INFERIOR_CPCL, 640);

  return `! 0 200 200 ${altura} 1\nPAGE-WIDTH 576\nTONE 0\nSPEED 3\nON-FEED IGNORE\nPREFEED 0\nPOSTFEED 0\n${body}PRINT\n`;
};

const obtenerImpresoraZebraDefault = () => {
  return new Promise((resolve, reject) => {
    if (!window.BrowserPrint) {
      reject(new Error("BrowserPrint no está disponible."));
      return;
    }

    window.BrowserPrint.getDefaultDevice(
      "printer",
      (device) => {
        if (!device) {
          reject(
            new Error(
              "No hay impresora predeterminada en Zebra Browser Print."
            )
          );
          return;
        }

        resolve(device);
      },
      (error) => {
        reject(
          new Error(
            error ||
              "No fue posible obtener la impresora predeterminada desde Zebra Browser Print."
          )
        );
      }
    );
  });
};

const enviarCpclAImpresora = async (cpcl) => {
  const printer = await obtenerImpresoraZebraDefault();

  return new Promise((resolve, reject) => {
    printer.send(
      cpcl,
      () => resolve(),
      (error) => {
        reject(new Error(error || "Error enviando CPCL a la impresora Zebra."));
      }
    );
  });
};

const imprimirUnaCopiaZebraEntrega = async ({
  docNum,
  formData,
  copyLabel = "ENTREGA",
}) => {
  const lineasImpresas = (formData.DocumentLines || []).filter(
    (linea) => Number(linea.Quantity || 0) > 0
  );

  if (lineasImpresas.length === 0) {
    throw new Error("No hay líneas con cantidad mayor a cero para imprimir.");
  }

  const cpcl = generarCPCLTermicoEntrega({
    docNum,
    formData,
    lineasImpresas,
    copyLabel,
  });

  await enviarCpclAImpresora(cpcl);
};

const pedirContinuarImpresion = async ({
  title = "Copia impresa",
  html = "Corte la copia impresa y luego presione <b>Enter</b> o haga clic en <b>Continuar</b>.",
} = {}) => {
  await Swal.fire({
    ...swalBase,
    icon: "info",
    title,
    html,
    confirmButtonText: "Continuar",
    allowOutsideClick: false,
    allowEscapeKey: false,
  });
};

const obtenerTotalCopiasSeguro = (copies) => {
  const parsed = Number(copies || 1);

  if (Number.isNaN(parsed)) return 1;

  return Math.min(3, Math.max(1, Math.floor(parsed)));
};

const imprimirEntregaZebraSecuencial = async ({
  docNum,
  formData,
  copyLabel = "ENTREGA",
  copies = 3,
  pausarDespuesUltimaCopia = false,
  siguienteDocumentoTexto = "el siguiente documento",
}) => {
  const totalCopias = obtenerTotalCopiasSeguro(copies);

  for (let copia = 1; copia <= totalCopias; copia += 1) {
    await imprimirUnaCopiaZebraEntrega({
      docNum,
      formData,
      copyLabel,
    });

    const hayOtraCopiaDelMismoDocumento = copia < totalCopias;
    const debePausarAntesDelSiguienteDocumento =
      copia === totalCopias && pausarDespuesUltimaCopia;

    if (hayOtraCopiaDelMismoDocumento || debePausarAntesDelSiguienteDocumento) {
      await pedirContinuarImpresion({
        title: hayOtraCopiaDelMismoDocumento
          ? `Copia ${copia} impresa`
          : `Documento ${docNum || ""} impreso`,
        html: hayOtraCopiaDelMismoDocumento
          ? `Corte la copia ${copia} y luego presione <b>Enter</b> o haga clic en <b>Continuar</b> para imprimir la copia ${copia + 1}.`
          : `Corte la última copia del documento ${escapeHtml(
              docNum || ""
            )} y luego presione <b>Enter</b> o haga clic en <b>Continuar</b> para imprimir ${escapeHtml(
              siguienteDocumentoTexto
            )}.`,
      });
    }
  }
};

const imprimirEntregaTermicaSecuencial = async ({
  logoUrl,
  docNum,
  formData,
  copyLabel = "ENTREGA",
  copies = 3,
  pausarDespuesUltimaCopia = false,
  siguienteDocumentoTexto = "el siguiente documento",
}) => {
  if (window.BrowserPrint) {
    let usarNavegadorWeb = false;

    while (!usarNavegadorWeb) {
      try {
        await imprimirEntregaZebraSecuencial({
          docNum,
          formData,
          copyLabel,
          copies,
          pausarDespuesUltimaCopia,
          siguienteDocumentoTexto,
        });
        return;
      } catch (error) {
        const respuesta = await Swal.fire({
          ...swalBase,
          icon: "warning",
          title: "No se pudo imprimir directo en Zebra",
          html: `${escapeHtml(
            error.message || "Error desconocido"
          )}<br/><br/>Puede reintentar la impresión CPCL, usar el navegador web o cancelar el proceso.`,
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Reintentar",
          denyButtonText: "Usar navegador web",
          cancelButtonText: "Cancelar",
          allowOutsideClick: false,
          allowEscapeKey: false,
        });

        if (respuesta.isConfirmed) {
          continue;
        }

        if (respuesta.isDenied) {
          usarNavegadorWeb = true;
          break;
        }

        throw error;
      }
    }
  }

  const totalCopias = obtenerTotalCopiasSeguro(copies);

  for (let copia = 1; copia <= totalCopias; copia += 1) {
    await imprimirUnaCopiaTermicaEntrega({
      logoUrl,
      docNum,
      formData,
      copyLabel,
    });

    const hayOtraCopiaDelMismoDocumento = copia < totalCopias;
    const debePausarAntesDelSiguienteDocumento =
      copia === totalCopias && pausarDespuesUltimaCopia;

    if (hayOtraCopiaDelMismoDocumento || debePausarAntesDelSiguienteDocumento) {
      await pedirContinuarImpresion({
        title: hayOtraCopiaDelMismoDocumento
          ? `Copia ${copia} impresa`
          : `Documento ${docNum || ""} impreso`,
        html: hayOtraCopiaDelMismoDocumento
          ? `Corte la copia ${copia} y luego presione <b>Enter</b> o haga clic en <b>Continuar</b> para imprimir la copia ${copia + 1}.`
          : `Corte la última copia del documento ${escapeHtml(
              docNum || ""
            )} y luego presione <b>Enter</b> o haga clic en <b>Continuar</b> para imprimir ${escapeHtml(
              siguienteDocumentoTexto
            )}.`,
      });
    }
  }
};

const Entregas = () => {
  const [ordenesVenta, setOrdenesVenta] = useState([]);
    const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [search, setSearch] = useState("");
  const [showOptions, setShowOptions] = useState(false);

  const [entregasCancelacion, setEntregasCancelacion] = useState([]);
  const [searchCancelacion, setSearchCancelacion] = useState("");
  const [showOptionsCancelacion, setShowOptionsCancelacion] = useState(false);

  const [docNumReimpresion, setDocNumReimpresion] = useState("");
  const [procesandoReimpresion, setProcesandoReimpresion] = useState(false);

  const [tagsUbicaciones, setTagsUbicaciones] = useState([]);

  const [modalOpen, setModalOpen] = useState(false);
  const [detalleOrdenVenta, setDetalleOrdenVenta] = useState(null);
  const [formData, setFormData] = useState(null);
  const [errorDetalle, setErrorDetalle] = useState("");

  const [modalCancelacionOpen, setModalCancelacionOpen] = useState(false);
  const [detalleEntregaCancelacion, setDetalleEntregaCancelacion] = useState(null);
  const [formDataCancelacion, setFormDataCancelacion] = useState(null);
  const [errorDetalleCancelacion, setErrorDetalleCancelacion] = useState("");

  const [modoConsolidado, setModoConsolidado] = useState(false);
  const [ordenesSeleccionadas, setOrdenesSeleccionadas] = useState([]);
  const [modalConsolidadoOpen, setModalConsolidadoOpen] = useState(false);
  const [formDataConsolidado, setFormDataConsolidado] = useState([]);
  const [procesandoConsolidado, setProcesandoConsolidado] = useState(false);
  const [codigoRutaDocumento, setCodigoRutaDocumento] = useState("");
  const [codigosRutaConsolidado, setCodigosRutaConsolidado] = useState({});
  const [codigoRutaCancelacion, setCodigoRutaCancelacion] = useState("");

  const [, setCurrentUserId] = useState("");
  const [nombreApellidoLogueado, setNombreApellidoLogueado] = useState("");

  const ordenSearchRef = useRef(null);
  const cancelacionSearchRef = useRef(null);
  const modalConsolidadoContentRef = useRef(null);
  const scannerAutoStatsRef = useRef({});
  const scannerAutoTimersRef = useRef({});
  const scannerAutoUltimoProcesadoRef = useRef({});
  const keyboardInputActivoRef = useRef(null);
  const keyboardHideTimeoutRef = useRef(null);
  const keyboardManualOpenRef = useRef(false);
  const [mobileKeyboardButton, setMobileKeyboardButton] = useState({
    visible: false,
    top: 0,
    left: 0,
  });

  const hayTrabajoEnCurso = useMemo(() => {
    const hayDocumentoNormal = Boolean(modalOpen && formData);
    const hayDocumentoCancelacion = Boolean(modalCancelacionOpen && formDataCancelacion);
    const haySeleccionConsolidado = Array.isArray(ordenesSeleccionadas) && ordenesSeleccionadas.length > 0;
    const hayModalConsolidado = Boolean(
      modalConsolidadoOpen && Array.isArray(formDataConsolidado) && formDataConsolidado.length > 0
    );

    return (
      hayDocumentoNormal ||
      hayDocumentoCancelacion ||
      haySeleccionConsolidado ||
      hayModalConsolidado ||
      procesandoConsolidado ||
      procesandoReimpresion
    );
  }, [
    modalOpen,
    formData,
    modalCancelacionOpen,
    formDataCancelacion,
    ordenesSeleccionadas,
    modalConsolidadoOpen,
    formDataConsolidado,
    procesandoConsolidado,
    procesandoReimpresion,
  ]);

  const obtenerInputModePorDefecto = (target) => {
    if (!target) return "text";

    if (target.dataset.keyboardDefaultInputMode) {
      return target.dataset.keyboardDefaultInputMode;
    }

    const inputModeActual = target.getAttribute("inputmode");
    if (inputModeActual && inputModeActual !== "none") return inputModeActual;

    if (target.tagName === "TEXTAREA") return "text";
    if (target.type === "number") return "numeric";
    if (target.type === "date") return "text";
    if (target.type === "tel") return "tel";
    if (target.type === "email") return "email";

    return "text";
  };

  const actualizarPosicionBotonTeclado = (target) => {
    if (!target || typeof target.getBoundingClientRect !== "function") return;

    const rect = target.getBoundingClientRect();
    const top = Math.max(8, rect.top + rect.height / 2 - 18);
    const left = Math.min(window.innerWidth - 48, Math.max(8, rect.right + 6));

    setMobileKeyboardButton({
      visible: true,
      top,
      left,
    });
  };

  const abrirTecladoManual = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const target = keyboardInputActivoRef.current;
    if (!target || target.disabled || target.readOnly) return;

    const inputModeOriginal = obtenerInputModePorDefecto(target);

    clearTimeout(keyboardHideTimeoutRef.current);

    // Marca que este focus viene del boton de teclado.
    // Asi el listener global de focus no vuelve a poner inputMode=none inmediatamente.
    keyboardManualOpenRef.current = true;
    target.setAttribute("inputmode", inputModeOriginal);

    // En Android/iOS el teclado solo se abre si focus ocurre dentro del gesto directo del usuario.
    // No hacemos blur antes de focus porque eso rompe el gesto en varios handhelds/Chrome Android.
    try {
      target.focus({ preventScroll: true });
    } catch (error) {
      target.focus();
    }

    if (typeof target.select === "function" && target.tagName !== "TEXTAREA") {
      try {
        target.select();
      } catch (error) {
        // Ignorar si el navegador no permite seleccionar en ese momento.
      }
    }

    if (typeof target.showPicker === "function" && target.type === "date") {
      try {
        target.showPicker();
      } catch (error) {
        // Algunos navegadores no permiten showPicker sin gesto directo.
      }
    }

    actualizarPosicionBotonTeclado(target);

    // Mantiene el inputMode real mientras el campo esta activo.
    // Al salir del campo se vuelve a inputMode=none en handleFocusOut.
    window.setTimeout(() => {
      keyboardManualOpenRef.current = false;
    }, 800);
  };

  useEffect(() => {
    let userid = "";
    let nombresap = "";
    let apellidosap = "";
    let NombreApellido = "";
    const token = localStorage.getItem("token");
    let token_Data = null;

    try {
      token_Data = JSON.parse(token);
    } catch (error) {
      token_Data = null;
    }

    if (token_Data !== null && Array.isArray(token_Data)) {
      token_Data.forEach((element) => {
        userid = element.U_UserId;
        nombresap = element.Nombre;
        apellidosap = element.Apellido;
        NombreApellido = `${nombresap || ""} ${apellidosap || ""}`.trim();
      });
    }

    if (token_Data === null) {
      window.location.href = "";
      return;
    }

    setCurrentUserId(String(userid || ""));
    setNombreApellidoLogueado(NombreApellido);
  }, []);

  useEffect(() => {
    const esCampoEditable = (target) => {
      if (!target) return false;
      const tagName = target.tagName;
      const esInput = tagName === "INPUT" || tagName === "TEXTAREA";
      const estaDentroComponente = target.closest?.(".entrega-stock-container");

      return Boolean(
        esInput &&
        estaDentroComponente &&
        !target.disabled &&
        !target.readOnly &&
        target.type !== "hidden" &&
        target.type !== "button" &&
        target.type !== "submit" &&
        target.type !== "checkbox"
      );
    };

    const prepararCampoSinTecladoAutomatico = (target) => {
      if (!target.dataset.keyboardDefaultInputMode) {
        target.dataset.keyboardDefaultInputMode = obtenerInputModePorDefecto(target);
      }

      target.setAttribute("inputmode", "none");
      target.setAttribute("autocomplete", "off");
      target.setAttribute("autocorrect", "off");
    };

    const handleFocusIn = (event) => {
      const target = event.target;
      if (!esCampoEditable(target)) return;

      clearTimeout(keyboardHideTimeoutRef.current);
      keyboardInputActivoRef.current = target;

      if (!keyboardManualOpenRef.current) {
        prepararCampoSinTecladoAutomatico(target);
      }

      actualizarPosicionBotonTeclado(target);
    };

    const handleFocusOut = () => {
      clearTimeout(keyboardHideTimeoutRef.current);
      keyboardHideTimeoutRef.current = setTimeout(() => {
        const target = keyboardInputActivoRef.current;
        if (!target || document.activeElement !== target) {
          if (target && esCampoEditable(target)) {
            target.setAttribute("inputmode", "none");
          }
          setMobileKeyboardButton((prev) => ({ ...prev, visible: false }));
        }
      }, 220);
    };

    const handleScrollOrResize = () => {
      const target = keyboardInputActivoRef.current;
      if (target && document.activeElement === target && esCampoEditable(target)) {
        actualizarPosicionBotonTeclado(target);
      }
    };

    document.addEventListener("focusin", handleFocusIn, true);
    document.addEventListener("focusout", handleFocusOut, true);
    window.addEventListener("scroll", handleScrollOrResize, true);
    window.addEventListener("resize", handleScrollOrResize);

    return () => {
      document.removeEventListener("focusin", handleFocusIn, true);
      document.removeEventListener("focusout", handleFocusOut, true);
      window.removeEventListener("scroll", handleScrollOrResize, true);
      window.removeEventListener("resize", handleScrollOrResize);
      clearTimeout(keyboardHideTimeoutRef.current);
    };
  }, []);

  useEffect(() => {
    if (!modalConsolidadoOpen) return undefined;

    const frameId = window.requestAnimationFrame(() => {
      const modalContent = modalConsolidadoContentRef.current;

      if (modalContent && typeof modalContent.scrollTo === "function") {
        modalContent.scrollTo({ top: 0, left: 0, behavior: "auto" });
      }

      const overlay = modalContent?.closest?.(".modal-overlay");

      if (overlay && typeof overlay.scrollTo === "function") {
        overlay.scrollTo({ top: 0, left: 0, behavior: "auto" });
      }

      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });

    return () => window.cancelAnimationFrame(frameId);
  }, [modalConsolidadoOpen]);

  useEffect(() => {
    if (!hayTrabajoEnCurso) return undefined;

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "¿Está seguro que desea salir o refrescar? Puede perder el trabajo en curso.";
      return event.returnValue;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hayTrabajoEnCurso]);

  useEffect(() => {
    if (!hayTrabajoEnCurso) return undefined;

    let salidaPermitida = false;

    window.history.pushState(
      { bloqueoSalidaEntregas: Date.now() },
      "",
      window.location.href
    );

    const handlePopState = async () => {
      if (salidaPermitida) return;

      window.history.pushState(
        { bloqueoSalidaEntregas: Date.now() },
        "",
        window.location.href
      );

      const respuesta = await Swal.fire({
        ...swalBase,
        icon: "warning",
        title: "¿Está seguro que desea salir?",
        text: "Si sale, regresa atrás o actualiza la página, puede perder el trabajo del documento actual.",
        showCancelButton: true,
        confirmButtonText: "Sí, salir",
        cancelButtonText: "Cancelar",
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      if (respuesta.isConfirmed) {
        salidaPermitida = true;
        window.removeEventListener("popstate", handlePopState);
        window.history.back();
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [hayTrabajoEnCurso]);

  const showLoadingAlert = (title) => {
    Swal.fire({
      ...swalBase,
      title,
      text: "Por favor espere...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  };

  const closeLoadingAlert = () => {
    Swal.close();
  };

  const fetchTagsUbicaciones = async () => {
    try {
      const res = await fetch(API_URL_TAGS, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "API-Key": API_KEY,
        },
      });

      const data = await res.json().catch(() => []);
      console.log(data);
      
      if (!res.ok) {
        throw new Error(data?.error || data?.message || "No fue posible cargar ubicaciones.");
      }

      setTagsUbicaciones(Array.isArray(data) ? data : data.data || []);
    } catch (err) {
      console.error("Error cargando ubicaciones de tags:", err);
      setTagsUbicaciones([]);
    }
  };

  const fetchOrdenesVenta = async () => {
    try {
      setLoading(true);
      setError("");
      showLoadingAlert("Cargando órdenes de venta");

      const res = await fetch(API_URL_ORDENES_VENTA, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "API-Key": API_KEY,
        },
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Error ${res.status}: ${text}`);
      }

      const data = await res.json();

      if (data.answer !== "true") {
        throw new Error(data.message || "Error al obtener las órdenes de venta");
      }

      setOrdenesVenta(data.data || []);
      closeLoadingAlert();
    } catch (err) {
      console.error(err);
      setError(err.message || "Ocurrió un error al cargar las ordenes");
      closeLoadingAlert();

      Swal.fire({
        ...swalBase,
        icon: "error",
        title: "Error",
        text: err.message || "Ocurrió un error al cargar las ordenes",
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchEntregasCancelacion = async () => {
    try {
      const res = await fetch(API_URL_ENTREGA_STOCK_CANCELACION, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "API-Key": API_KEY,
        },
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Error ${res.status}: ${text}`);
      }

      const data = await res.json();

      if (data.answer !== "true") {
        throw new Error(
          data.message || "Error al obtener las entregas"
        );
      }

      setEntregasCancelacion(data.data || []);
    } catch (err) {
      console.error("Error cargando entregas:", err);

      Swal.fire({
        ...swalBase,
        icon: "error",
        title: "Error",
        text:
          err.message ||
          "No fue posible cargar las entregas para cancelación.",
      });
    }
  };

  const construirFormDataEntregaCancelacion = (detalle, nombreUsuario = nombreApellidoLogueado, lineasConStock = null) => {
    const detalleNormalizado = normalizarDocumentoConLineas(detalle);
    const documentLines = Array.isArray(lineasConStock)
      ? lineasConStock
      : Array.isArray(detalleNormalizado?.DocumentLines)
      ? detalleNormalizado.DocumentLines.map((linea, index) =>
          construirLineaDesdeDetalle(linea, index, false)
        )
      : [];

    const resumen = calcularResumenDocumento(documentLines);
    const comentarioBase = detalle?.Comments || "";

    return {
      DocEntry: detalle?.DocEntry || "",
      DocNum: detalle?.DocNum || "",
      FromWarehouseCode: obtenerTexto(detalle?.FromWarehouseCode, detalle?.FromWhsCod, detalle?.FromWhsCode, detalle?.Filler, documentLines?.[0]?.FromWarehouseCode),
      WarehouseCode: obtenerTexto(detalle?.WarehouseCode, detalle?.WhsCode, detalle?.ToWhsCode, detalle?.ToWhsCod, documentLines?.[0]?.WarehouseCode),
      TaxDate: formatDateForInput(detalle?.TaxDate),
      DocDueDate: obtenerFechaVencimiento(detalle),
      DocDate: formatDateForInput(detalle?.DocDate),
      CommentsBase: construirComentarioConUsuario(nombreUsuario, comentarioBase),
      DocumentLines: resumen.lineas,
    };
  };

  const construirFormDataReimpresionEntrega = (detalle, lineasConStock = null) => {
    const detalleNormalizado = normalizarDocumentoConLineas(detalle);
    const documentLines = Array.isArray(lineasConStock)
      ? lineasConStock
      : Array.isArray(detalleNormalizado?.DocumentLines)
      ? detalleNormalizado.DocumentLines.map((linea, index) =>
          construirLineaDesdeDetalle(linea, index, false)
        )
      : [];

    const resumen = calcularResumenDocumento(documentLines);
    const comentarioBase = detalleNormalizado?.Comments || detalle?.Comments || "";

    return {
      DocEntry: detalleNormalizado?.DocEntry || "",
      DocNum: detalleNormalizado?.DocNum || "",
      FromWarehouseCode: obtenerTexto(
        detalleNormalizado?.FromWarehouseCode,
        detalleNormalizado?.FromWhsCod,
        detalleNormalizado?.FromWhsCode,
        detalleNormalizado?.Filler,
        documentLines?.[0]?.FromWarehouseCode
      ),
      WarehouseCode: obtenerTexto(
        detalleNormalizado?.WarehouseCode,
        detalleNormalizado?.WhsCode,
        detalleNormalizado?.ToWhsCode,
        detalleNormalizado?.ToWhsCod,
        documentLines?.[0]?.WarehouseCode
      ),
      TaxDate: formatDateForInput(detalleNormalizado?.TaxDate),
      DocDueDate: obtenerFechaVencimiento(detalleNormalizado),
      DocDate: formatDateForInput(detalleNormalizado?.DocDate),
      CommentsBase: comentarioBase,
      Comments: comentarioBase,
      DocumentLines: resumen.lineas,
    };
  };

  const obtenerDocEntryPorDocNumEntrega = (docNumBuscado) => {
    const docNumNormalizado = String(docNumBuscado || "").trim();

    if (!docNumNormalizado) return "";

    const entrega = (entregasCancelacion || []).find(
      (item) => String(item?.DocNum || "").trim() === docNumNormalizado
    );

    return entrega?.DocEntry || "";
  };


  const obtenerClaveAgrupacionConsolidado = (linea) => {
    // Agrupa por codigo + almacen origen + almacen destino.
    // Si el mismo articulo viene en almacenes diferentes, se muestra por separado.
    const itemCode = normalizarItemCode(obtenerCodigoArticulo(linea));
    const almacenOrigen = normalizarCodigoRuta(obtenerAlmacenOrigen(linea));
    const almacenDestino = normalizarCodigoRuta(obtenerAlmacenDestino(linea));

    return `${itemCode}|${almacenOrigen}|${almacenDestino}`;
  };

  const clonarLineaBaseGrupo = (linea) => ({
    ...linea,
    Quantity: Number(linea.Quantity || 0),
    OpenQuantity: Number(linea.OpenQuantity || 0),
    PrecioInfo: Number(linea.PrecioInfo || 0),
    PrecioConIVA: Number(linea.PrecioConIVA || 0),
  });

  const agruparLineasConsolidadoPorArticuloAlmacenes = (lines = []) => {
    const grupos = new Map();

    lines.forEach((linea, index) => {
      const lineaBase = clonarLineaBaseGrupo({
        ...linea,
        __OriginalIndex: index,
      });
      const clave = obtenerClaveAgrupacionConsolidado(lineaBase);

      if (!grupos.has(clave)) {
        grupos.set(clave, {
          ...lineaBase,
          LineNum: obtenerNumeroLineaBase(lineaBase, index),
          Quantity: 0,
          OpenQuantity: 0,
          LineasOriginalesGrupo: [],
          EsLineaAgrupada: false,
          CantidadLineasAgrupadas: 0,
        });
      }

      const grupo = grupos.get(clave);
      grupo.Quantity = round4(Number(grupo.Quantity || 0) + Number(lineaBase.Quantity || 0));
      grupo.OpenQuantity = round4(Number(grupo.OpenQuantity || 0) + Number(lineaBase.OpenQuantity || 0));
      grupo.LineasOriginalesGrupo.push(lineaBase);
      grupo.CantidadLineasAgrupadas = grupo.LineasOriginalesGrupo.length;
      grupo.EsLineaAgrupada = grupo.LineasOriginalesGrupo.length > 1;
    });

    return Array.from(grupos.values()).map((grupo) =>
      enriquecerLinea({
        ...grupo,
        QuantityInput: String(grupo.Quantity || 0),
        GroupLabel: grupo.EsLineaAgrupada
          ? `${grupo.CantidadLineasAgrupadas} líneas agrupadas`
          : "Sin agrupación",
      })
    );
  };

  const distribuirCantidadLineaAgrupada = (linea) => {
    const originales = Array.isArray(linea.LineasOriginalesGrupo) && linea.LineasOriginalesGrupo.length > 0
      ? linea.LineasOriginalesGrupo
      : [linea];

    let cantidadPendientePorAsignar = Number(linea.Quantity || 0);

    return originales
      .map((original, index) => {
        const maximoLinea = Number(original.OpenQuantity ?? original.Quantity ?? 0);
        const cantidadLinea = Math.min(Math.max(cantidadPendientePorAsignar, 0), maximoLinea);
        cantidadPendientePorAsignar = round4(cantidadPendientePorAsignar - cantidadLinea);

        return enriquecerLinea({
          ...original,
          Quantity: cantidadLinea,
          // Se conservan los almacenes originales de cada orden para que SAP cree
          // las entregas individuales correctamente, aunque el consolidado visual
          // agrupe por codigo.
          WarehouseCode: obtenerAlmacenDestino(original) || obtenerAlmacenDestino(linea),
          FromWarehouseCode: obtenerAlmacenOrigen(original) || obtenerAlmacenOrigen(linea),
          RutaScanStatus: linea.RutaScanStatus,
          CodigoRutaEscaneado: linea.CodigoRutaEscaneado,
          RutaScanLocation: linea.RutaScanLocation,
          LineNum: obtenerNumeroLineaBase(original, index),
        });
      })
      .filter((original) => Number(original.Quantity || 0) > 0);
  };

  const expandirLineasConsolidadasParaSAP = (lines = []) => {
    return lines.flatMap((linea) => distribuirCantidadLineaAgrupada(linea));
  };

  const normalizarCopiasImpresion = (value) => {
    const limpio = sanitizeDecimalInput(value).replace(/\./g, "");

    if (!limpio) return "";

    const numero = Number(limpio);

    if (Number.isNaN(numero)) return "";

    return String(Math.min(3, Math.max(1, Math.floor(numero))));
  };

  const obtenerCantidadCopiasDocumento = (documento) => {
    const parsed = Number(documento?.Copies || 1);

    if (Number.isNaN(parsed)) return 1;

    return Math.min(3, Math.max(1, Math.floor(parsed)));
  };


  const construirFormDataOrdenVenta = async (docEntry) => {
    const res = await fetch(`${API_URL_DETALLE_ORDEN_VENTA}/${docEntry}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "API-Key": API_KEY,
      },
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Error ${res.status}: ${text}`);
    }

    const data = await res.json();

    if (data.answer !== "true") {
      throw new Error(data.message || "Error al obtener el detalle de la orden");
    }

    const detalle = normalizarDocumentoConLineas(data.data);
    const documentLinesBase = Array.isArray(detalle?.DocumentLines)
      ? detalle.DocumentLines.map((linea, index) =>
          construirLineaDesdeDetalle(linea, index, true)
        )
      : [];

    const documentLines = await enriquecerLineasConStockOrigen(documentLinesBase);
    const resumen = calcularResumenDocumento(documentLines);
    const comentarioBase = detalle?.Comments || "";

    return {
      DocEntry: detalle?.DocEntry || "",
      DocNum: detalle?.DocNum || "",
      FromWarehouseCode: obtenerTexto(detalle?.FromWarehouseCode, detalle?.FromWhsCod, detalle?.FromWhsCode, detalle?.Filler, documentLines?.[0]?.FromWarehouseCode),
      WarehouseCode: obtenerTexto(detalle?.WarehouseCode, detalle?.WhsCode, detalle?.ToWhsCode, detalle?.ToWhsCod, documentLines?.[0]?.WarehouseCode),
      TaxDate: formatDateForInput(detalle?.TaxDate),
      DocDueDate: obtenerFechaVencimiento(detalle),
      DocDate: formatDateForInput(detalle?.DocDate),
      CommentsBase: construirComentarioConUsuario(nombreApellidoLogueado, comentarioBase),
      DocumentLines: resumen.lineas,
    };
  };

  const fetchDetalleOrdenVenta = async (docEntry) => {
    try {
      setErrorDetalle("");
      setDetalleOrdenVenta(null);
      setFormData(null);

      showLoadingAlert("Cargando detalle de la orden");

      const res = await fetch(`${API_URL_DETALLE_ORDEN_VENTA}/${docEntry}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "API-Key": API_KEY,
        },
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Error ${res.status}: ${text}`);
      }

      const data = await res.json();

      if (data.answer !== "true") {
        throw new Error(data.message || "Error al obtener el detalle de la orden");
      }

      const detalle = normalizarDocumentoConLineas(data.data);
      setDetalleOrdenVenta(detalle);

  const documentLinesBase = Array.isArray(detalle?.DocumentLines)
  ? detalle.DocumentLines
      .map((linea, index) =>
        construirLineaDesdeDetalle(linea, index, true)
      )
      .filter((linea) => Number(linea.OpenQuantity || 0) > 0)
  : [];
 
      const documentLines = await enriquecerLineasConStockOrigen(documentLinesBase);

      const resumen = calcularResumenDocumento(documentLines);
      const comentarioBase = detalle?.Comments || "";
      const fechaHoy = new Date().toISOString().split("T")[0];
      setFormData({
        DocEntry: detalle?.DocEntry || "",
        DocNum: detalle?.DocNum || "",
        FromWarehouseCode: obtenerTexto(detalle?.FromWarehouseCode, detalle?.FromWhsCod, detalle?.FromWhsCode, detalle?.Filler, documentLines?.[0]?.FromWarehouseCode),
        WarehouseCode: obtenerTexto(detalle?.WarehouseCode, detalle?.WhsCode, detalle?.ToWhsCode, detalle?.ToWhsCod, documentLines?.[0]?.WarehouseCode),

        DocDate: fechaHoy,
        TaxDate: fechaHoy,
        DocDueDate: fechaHoy,
        CommentsBase: construirComentarioConUsuario(nombreApellidoLogueado, comentarioBase),
        DocumentLines: resumen.lineas,
      });

      closeLoadingAlert();
      setModalOpen(true);
    } catch (err) {
      console.error(err);
      setErrorDetalle(err.message || "Ocurrió un error al obtener el detalle");
      closeLoadingAlert();

      Swal.fire({
        ...swalBase,
        icon: "error",
        title: "Error al cargar detalle",
        text: err.message || "Ocurrió un error al obtener el detalle",
      });
    }
  };

  const fetchDetalleEntregaCancelacion = async (docEntry) => {
    try {
      setErrorDetalleCancelacion("");
      setDetalleEntregaCancelacion(null);
      setFormDataCancelacion(null);

      showLoadingAlert("Cargando detalle de la entrega");

      const res = await fetch(`${API_URL_DETALLE_ENTREGA}/${docEntry}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "API-Key": API_KEY,
        },
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Error ${res.status}: ${text}`);
      }

      const data = await res.json();

      if (data.answer !== "true") {
        throw new Error(data.message || "Error al obtener el detalle de la entrega");
      }

      const detalle = normalizarDocumentoConLineas(data.data);
      const documentLinesBase = Array.isArray(detalle?.DocumentLines)
        ? detalle.DocumentLines.map((linea, index) =>
            construirLineaDesdeDetalle(linea, index, false)
          )
        : [];
      const documentLines = await enriquecerLineasConStockOrigen(documentLinesBase);

      setDetalleEntregaCancelacion(detalle);
      setFormDataCancelacion(
        construirFormDataEntregaCancelacion(
          detalle,
          nombreApellidoLogueado,
          documentLines
        )
      );

      closeLoadingAlert();
      setModalCancelacionOpen(true);
    } catch (err) {
      console.error(err);
      setErrorDetalleCancelacion(
        err.message || "Ocurrió un error al obtener el detalle de la entrega"
      );
      closeLoadingAlert();

      Swal.fire({
        ...swalBase,
        icon: "error",
        title: "Error al cargar detalle",
        text: err.message || "Ocurrió un error al obtener el detalle de la entrega",
      });
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const target = event.target;

      if (ordenSearchRef.current && !ordenSearchRef.current.contains(target)) {
        setShowOptions(false);
      }

      if (
        cancelacionSearchRef.current &&
        !cancelacionSearchRef.current.contains(target)
      ) {
        setShowOptionsCancelacion(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    fetchOrdenesVenta();
    fetchEntregasCancelacion();
    fetchTagsUbicaciones();
  }, []);

  const tagsPorItemCode = useMemo(() => {
    const map = new Map();

    tagsUbicaciones.forEach((tag) => {
      const itemCode = normalizarItemCode(tag?.ItemCode);
      if (!itemCode) return;

      if (!map.has(itemCode)) {
        map.set(itemCode, []);
      }

      map.get(itemCode).push(tag);
    });

    return map;
  }, [tagsUbicaciones]);

  const tagsPorNumeroTag = useMemo(() => {
    const map = new Map();

    tagsUbicaciones.forEach((tag) => {
      const numeroTag = normalizarCodigoRuta(obtenerNumberTag(tag));
      if (!numeroTag || map.has(numeroTag)) return;
      map.set(numeroTag, tag);
    });

    return map;
  }, [tagsUbicaciones]);

  const filteredOrdenesVenta = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return ordenesVenta;

    return ordenesVenta.filter((item) =>
      String(item.DocNum || "").toLowerCase().includes(q)
    );
  }, [ordenesVenta, search]);

  const filteredEntregasCancelacion = useMemo(() => {
    const q = searchCancelacion.trim().toLowerCase();
    if (!q) return entregasCancelacion;

    return entregasCancelacion.filter((item) =>
      String(item.DocNum || "").toLowerCase().includes(q)
    );
  }, [entregasCancelacion, searchCancelacion]);

  const comentarioCompleto = formData?.CommentsBase ?? "";
  const comentarioCompletoCancelacion = formDataCancelacion?.CommentsBase ?? "";

  const ordenesSeleccionadasIds = useMemo(() => {
    return new Set(
      ordenesSeleccionadas.map((orden) => String(orden.DocEntry || ""))
    );
  }, [ordenesSeleccionadas]);

  const toggleOrdenConsolidado = (orden) => {
    setOrdenesSeleccionadas((prev) => {
      const docEntry = String(orden.DocEntry || "");
      const existe = prev.some((item) => String(item.DocEntry || "") === docEntry);

      if (existe) {
        return prev.filter((item) => String(item.DocEntry || "") !== docEntry);
      }

      return [...prev, orden];
    });
  };

  const handleSelectOrdenVenta = (orden) => {
    if (modoConsolidado) {
      toggleOrdenConsolidado(orden);
      setSearch("");
      setShowOptions(true);
      return;
    }

    setSearch(String(orden.DocNum || ""));
    setShowOptions(false);
    fetchDetalleOrdenVenta(orden.DocEntry);
  };

  const limpiarSeleccionOrdenesConsolidado = () => {
    setOrdenesSeleccionadas([]);
    setFormDataConsolidado([]);
  };

  const confirmarCierreModal = async ({
    title = "¿Desea cerrar este modal?",
    text = "Si cierra, puede perder los cambios o la información cargada.",
  } = {}) => {
    const respuesta = await Swal.fire({
      ...swalBase,
      icon: "warning",
      title,
      text,
      showCancelButton: true,
      confirmButtonText: "Sí, cerrar",
      cancelButtonText: "No cerrar",
      allowOutsideClick: false,
      allowEscapeKey: false,
    });

    return respuesta.isConfirmed;
  };

  const cerrarModalConsolidadoSinConfirmar = () => {
    setModalConsolidadoOpen(false);
    setFormDataConsolidado([]);
  };

  const closeModalConsolidado = async () => {
    if (procesandoConsolidado) return;

    const confirmado = await confirmarCierreModal({
      title: "¿Cerrar consolidado?",
      text: "Si cierra este modal, perderá el consolidado preparado.",
    });

    if (!confirmado) return;

    cerrarModalConsolidadoSinConfirmar();
  };

  const abrirConsolidado = async () => {
    try {
      if (ordenesSeleccionadas.length === 0) {
        Swal.fire({
          ...swalBase,
          icon: "warning",
          title: "Sin documentos",
          text: "Debe seleccionar al menos una orden de venta para consolidado.",
        });
        return;
      }

      showLoadingAlert("Cargando consolidado");

      const documentosOrigen = [];
      const todasLasLineas = [];

      for (const orden of ordenesSeleccionadas) {
        const documento = await construirFormDataOrdenVenta(orden.DocEntry);
        documentosOrigen.push(documento);

         (documento.DocumentLines || []).forEach((linea, index) => {
  if (lineaEstaCerrada(linea)) {
    return;
  }
  todasLasLineas.push({
    ...linea,
    DocEntryOrigen: documento.DocEntry,
    DocNumOrigen: documento.DocNum,
    DocDateOrigen: documento.DocDate,
    TaxDateOrigen: documento.TaxDate,
    CommentsBaseOrigen: documento.CommentsBase,
    LineNum: obtenerNumeroLineaBase(linea, index),
  });
});
      }

      const primerDocumento = documentosOrigen[0] || {};
      const lineasAgrupadas = agruparLineasConsolidadoPorArticuloAlmacenes(todasLasLineas);

      setFormDataConsolidado([
        {
          ...primerDocumento,
          DocEntry: "",
          DocNum: "CONSOLIDADO",
          EsDocumentoConsolidado: true,
          EsConsolidadoUnico: true,
          Copies: "3",
          DocumentosOrigen: documentosOrigen,
          CommentsBase: primerDocumento.CommentsBase || "",
          DocumentLines: lineasAgrupadas,
        },
      ]);

      closeLoadingAlert();
      setModalConsolidadoOpen(true);
    } catch (err) {
      console.error(err);
      closeLoadingAlert();

      Swal.fire({
        ...swalBase,
        icon: "error",
        title: "Error al cargar consolidado",
        text: err.message || "No fue posible cargar los documentos seleccionados.",
      });
    }
  };

  const handleSelectEntregaCancelacion = (entrega) => {
    setSearchCancelacion(String(entrega.DocNum || ""));
    setShowOptionsCancelacion(false);
    fetchDetalleEntregaCancelacion(entrega.DocEntry);
  };

  const handleHeaderChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleCommentsChange = (value) => {
    setFormData((prev) =>
      prev
        ? {
            ...prev,
            CommentsBase: value,
          }
        : prev
    );
  };

  const actualizarResumenEnEstado = (updatedLines) => {
    const resumen = calcularResumenDocumento(updatedLines);

    return {
      DocumentLines: resumen.lineas,
    };
  };

  const handleLineChange = (index, field, value) => {
    setFormData((prev) => {
      if (!prev) return prev;

      const updatedLines = [...prev.DocumentLines];
      const lineaActual = updatedLines[index];

      if (lineaActual.IsClosedLine || Number(lineaActual.OpenQuantity || 0) <= 0) {
        return prev;
      }

      let nuevoValor = value;
      const extraFields = {};

      if (field === "Quantity") {
        const limpio = sanitizeDecimalInput(value);
        nuevoValor = parseDecimal(limpio);
        extraFields[`${field}Input`] = limpio;
      }

      updatedLines[index] = enriquecerLinea({
        ...updatedLines[index],
        ...extraFields,
        [field]: nuevoValor,
      });

      const resumenActualizado = actualizarResumenEnEstado(updatedLines);

      return {
        ...prev,
        ...resumenActualizado,
      };
    });
  };

  const handleLineInputBlur = (index, field) => {
    setFormData((prev) => {
      if (!prev) return prev;

      const updatedLines = [...prev.DocumentLines];
      const lineaActual = updatedLines[index];

      if (!lineaActual) return prev;

      const inputField = `${field}Input`;
      const valorNumerico = parseDecimal(lineaActual[inputField] ?? lineaActual[field]);

      updatedLines[index] = enriquecerLinea({
        ...lineaActual,
        [inputField]: valorNumerico ? String(valorNumerico) : "0",
        [field]: valorNumerico,
      });

      const resumenActualizado = actualizarResumenEnEstado(updatedLines);

      return {
        ...prev,
        ...resumenActualizado,
      };
    });
  };



  const actualizarDocumentoConsolidado = (documentoIndex, updater) => {
    setFormDataConsolidado((prev) => {
      if (!Array.isArray(prev)) return prev;

      return prev.map((documento, index) => {
        if (index !== documentoIndex) return documento;
        return updater(documento);
      });
    });
  };

  const handleHeaderConsolidadoChange = (documentoIndex, field, value) => {
    actualizarDocumentoConsolidado(documentoIndex, (documento) => ({
      ...documento,
      [field]: value,
    }));
  };

  const handleCommentsConsolidadoChange = (documentoIndex, value) => {
    actualizarDocumentoConsolidado(documentoIndex, (documento) => ({
      ...documento,
      CommentsBase: value,
    }));
  };


  const handleCopiesConsolidadoChange = (documentoIndex, value) => {
    const copies = normalizarCopiasImpresion(value);

    actualizarDocumentoConsolidado(documentoIndex, (documento) => ({
      ...documento,
      Copies: copies,
    }));
  };

  const handleCopiesConsolidadoBlur = (documentoIndex) => {
    actualizarDocumentoConsolidado(documentoIndex, (documento) => ({
      ...documento,
      Copies: normalizarCopiasImpresion(documento.Copies) || "1",
    }));
  };

  const handleLineConsolidadoChange = (documentoIndex, lineIndex, field, value) => {
    actualizarDocumentoConsolidado(documentoIndex, (documento) => {
      if (!documento || !Array.isArray(documento.DocumentLines)) return documento;

      const updatedLines = [...documento.DocumentLines];
      const lineaActual = updatedLines[lineIndex];

      if (!lineaActual || lineaActual.IsClosedLine || Number(lineaActual.OpenQuantity || 0) <= 0) {
        return documento;
      }

      let nuevoValor = value;
      const extraFields = {};

      if (field === "Quantity") {
        const limpio = sanitizeDecimalInput(value);
        nuevoValor = parseDecimal(limpio);
        extraFields[`${field}Input`] = limpio;
      }

      const lineasOriginalesGrupo = Array.isArray(lineaActual.LineasOriginalesGrupo)
        ? lineaActual.LineasOriginalesGrupo.map((lineaOriginal) => ({
            ...lineaOriginal,
            ...(field === "WarehouseCode" ? { WarehouseCode: nuevoValor } : {}),
          }))
        : lineaActual.LineasOriginalesGrupo;

      updatedLines[lineIndex] = enriquecerLinea({
        ...lineaActual,
        ...extraFields,
        LineasOriginalesGrupo: lineasOriginalesGrupo,
        [field]: nuevoValor,
      });

      return {
        ...documento,
        ...actualizarResumenEnEstado(updatedLines),
      };
    });
  };

  const handleLineConsolidadoInputBlur = (documentoIndex, lineIndex, field) => {
    actualizarDocumentoConsolidado(documentoIndex, (documento) => {
      if (!documento || !Array.isArray(documento.DocumentLines)) return documento;

      const updatedLines = [...documento.DocumentLines];
      const lineaActual = updatedLines[lineIndex];

      if (!lineaActual) return documento;

      const inputField = `${field}Input`;
      const valorNumerico = parseDecimal(lineaActual[inputField] ?? lineaActual[field]);

      updatedLines[lineIndex] = enriquecerLinea({
        ...lineaActual,
        [inputField]: valorNumerico ? String(valorNumerico) : "0",
        [field]: valorNumerico,
      });

      return {
        ...documento,
        ...actualizarResumenEnEstado(updatedLines),
      };
    });
  };

  const handleEliminarLineaConsolidado = async (documentoIndex, lineIndex) => {
    const documentoActual = formDataConsolidado?.[documentoIndex];
    const lineasActuales = documentoActual?.DocumentLines || [];
    const lineasRestantes = lineasActuales.filter((_, i) => i !== lineIndex);

    const confirmacion = await Swal.fire({
      ...swalBase,
      icon: "warning",
      title: "Eliminar línea",
      text: "¿Desea eliminar esta línea del detalle consolidado?",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });

    if (!confirmacion.isConfirmed) return;

    if (lineasRestantes.length === 0) {
      await Swal.fire({
        ...swalBase,
        icon: "info",
        title: "Documento sin líneas",
        text: `La orden ${documentoActual?.DocNum || ""} se quitará del consolidado porque ya no tiene líneas.`,
        confirmButtonText: "Entendido",
      });

      setFormDataConsolidado((prev) =>
        (prev || []).filter((_, index) => index !== documentoIndex)
      );

      setOrdenesSeleccionadas((prev) =>
        (prev || []).filter(
          (orden) =>
            String(orden.DocEntry || "") !== String(documentoActual?.DocEntry || "")
        )
      );

      return;
    }

    actualizarDocumentoConsolidado(documentoIndex, (documento) => ({
      ...documento,
      ...actualizarResumenEnEstado(lineasRestantes),
    }));
  };

  const actualizarEscaneoRutaLinea = ({ index, codigo, estado, ubicacionEscaneada = "", tipo = "orden" }) => {
    const setState = tipo === "cancelacion" ? setFormDataCancelacion : setFormData;

    setState((prev) => {
      if (!prev || !Array.isArray(prev.DocumentLines)) return prev;

      const updatedLines = [...prev.DocumentLines];
      const lineaActual = updatedLines[index];
      if (!lineaActual) return prev;

      updatedLines[index] = {
        ...lineaActual,
        CodigoRutaEscaneado: codigo,
        RutaScanStatus: estado,
        RutaScanLocation: ubicacionEscaneada,
      };

      return {
        ...prev,
        DocumentLines: updatedLines,
      };
    });
  };

  const handleCodigoRutaChange = (index, value, tipo = "orden") => {
    actualizarEscaneoRutaLinea({
      index,
      codigo: value,
      estado: "",
      ubicacionEscaneada: "",
      tipo,
    });
  };

  const handleValidarCodigoRuta = async (index, value, tipo = "orden") => {
    const dataActual = tipo === "cancelacion" ? formDataCancelacion : formData;
    const linea = dataActual?.DocumentLines?.[index];
    const codigoEscaneado = String(value || "").trim();
    const codigoNormalizado = normalizarCodigoRuta(codigoEscaneado);

    if (!linea || !codigoNormalizado) {
      actualizarEscaneoRutaLinea({
        index,
        codigo: codigoEscaneado,
        estado: "",
        ubicacionEscaneada: "",
        tipo,
      });
      return;
    }

    const numberTagEsperado = normalizarCodigoRuta(
      obtenerNumberTagLinea(linea, tagsPorItemCode)
    );
    const codigoArticuloEsperado = normalizarCodigoRuta(obtenerCodigoArticulo(linea));

    const tagEscaneado = tagsPorNumeroTag.get(codigoNormalizado) || null;
    const ubicacionEscaneada = obtenerLocationDescTag(tagEscaneado) || "No se encontró una ubicación para este código.";

    if (
      (numberTagEsperado && codigoNormalizado === numberTagEsperado) ||
      (codigoArticuloEsperado && codigoNormalizado === codigoArticuloEsperado)
    ) {
      actualizarEscaneoRutaLinea({
        index,
        codigo: codigoEscaneado,
        estado: "valid",
        ubicacionEscaneada: obtenerUbicacionLinea(linea, tagsPorItemCode) || "Validado por código de artículo",
        tipo,
      });
      return;
    }

    actualizarEscaneoRutaLinea({
      index,
      codigo: codigoEscaneado,
      estado: "invalid",
      ubicacionEscaneada,
      tipo,
    });

    await Swal.fire({
      ...swalBase,
      icon: "error",
      title: "Ubicación incorrecta",
      html: `
        <div class="swal-barcode-error">
          <div class="swal-barcode-error-icon">
            <i class="fa-solid fa-circle-xmark" aria-hidden="true"></i>
          </div>
          <div>El código escaneado está ubicado en:</div>
          <strong>${escapeHtml(ubicacionEscaneada)}</strong>
        </div>
      `,
      confirmButtonText: "Entendido",
    });
  };


  const actualizarEscaneoRutaLineaConsolidado = ({ documentoIndex, lineIndex, codigo, estado, ubicacionEscaneada = "" }) => {
    actualizarDocumentoConsolidado(documentoIndex, (documento) => {
      if (!documento || !Array.isArray(documento.DocumentLines)) return documento;

      const updatedLines = [...documento.DocumentLines];
      const lineaActual = updatedLines[lineIndex];
      if (!lineaActual) return documento;

      updatedLines[lineIndex] = {
        ...lineaActual,
        CodigoRutaEscaneado: codigo,
        RutaScanStatus: estado,
        RutaScanLocation: ubicacionEscaneada,
      };

      return {
        ...documento,
        DocumentLines: updatedLines,
      };
    });
  };

  const handleCodigoRutaConsolidadoChange = (documentoIndex, lineIndex, value) => {
    actualizarEscaneoRutaLineaConsolidado({
      documentoIndex,
      lineIndex,
      codigo: value,
      estado: "",
      ubicacionEscaneada: "",
    });
  };

  const handleValidarCodigoRutaConsolidado = async (documentoIndex, lineIndex, value) => {
    const documento = formDataConsolidado?.[documentoIndex];
    const linea = documento?.DocumentLines?.[lineIndex];
    const codigoEscaneado = String(value || "").trim();
    const codigoNormalizado = normalizarCodigoRuta(codigoEscaneado);

    if (!linea || !codigoNormalizado) {
      actualizarEscaneoRutaLineaConsolidado({
        documentoIndex,
        lineIndex,
        codigo: codigoEscaneado,
        estado: "",
        ubicacionEscaneada: "",
      });
      return;
    }

    const numberTagEsperado = normalizarCodigoRuta(
      obtenerNumberTagLinea(linea, tagsPorItemCode)
    );
    const codigoArticuloEsperado = normalizarCodigoRuta(obtenerCodigoArticulo(linea));

    const tagEscaneado = tagsPorNumeroTag.get(codigoNormalizado) || null;
    const ubicacionEscaneada = obtenerLocationDescTag(tagEscaneado) || "No se encontró una ubicación para este código.";

    if (
      (numberTagEsperado && codigoNormalizado === numberTagEsperado) ||
      (codigoArticuloEsperado && codigoNormalizado === codigoArticuloEsperado)
    ) {
      actualizarEscaneoRutaLineaConsolidado({
        documentoIndex,
        lineIndex,
        codigo: codigoEscaneado,
        estado: "valid",
        ubicacionEscaneada: obtenerUbicacionLinea(linea, tagsPorItemCode) || "Validado por código de artículo",
      });
      return;
    }

    actualizarEscaneoRutaLineaConsolidado({
      documentoIndex,
      lineIndex,
      codigo: codigoEscaneado,
      estado: "invalid",
      ubicacionEscaneada,
    });

    await Swal.fire({
      ...swalBase,
      icon: "error",
      title: "Ubicación incorrecta",
      html: `
        <div class="swal-barcode-error">
          <div class="swal-barcode-error-icon">
            <i class="fa-solid fa-circle-xmark" aria-hidden="true"></i>
          </div>
          <div>El código escaneado está ubicado en:</div>
          <strong>${escapeHtml(ubicacionEscaneada)}</strong>
        </div>
      `,
      confirmButtonText: "Entendido",
    });
  };

  const buscarIndicesLineasPorCodigoEscaneado = (lineas = [], codigoEscaneado = "") => {
    const codigoNormalizado = normalizarCodigoRuta(codigoEscaneado);

    if (!codigoNormalizado || !Array.isArray(lineas)) return [];

    const tagEscaneado = tagsPorNumeroTag.get(codigoNormalizado) || null;
    const itemCodeTagEscaneado = normalizarCodigoRuta(tagEscaneado?.ItemCode);

    return lineas
      .map((linea, index) => ({ linea, index }))
      .filter(({ linea }) => {
        if (
          !linea ||
          lineaEstaCerrada(linea) ||
          Number(linea.Quantity || 0) <= 0 ||
          linea.RutaScanStatus === "valid"
        ) {
          return false;
        }

        const numberTagEsperado = normalizarCodigoRuta(
          obtenerNumberTagLinea(linea, tagsPorItemCode)
        );
        const codigoArticuloEsperado = normalizarCodigoRuta(obtenerCodigoArticulo(linea));

        return Boolean(
          (numberTagEsperado && codigoNormalizado === numberTagEsperado) ||
            (codigoArticuloEsperado && codigoNormalizado === codigoArticuloEsperado) ||
            (itemCodeTagEscaneado && codigoArticuloEsperado === itemCodeTagEscaneado)
        );
      });
  };

  const seleccionarCoincidenciaPorAlmacenTag = ({
    coincidencias = [],
    tagEscaneado = null,
  }) => {
    const almacenTag = normalizarCodigoRuta(obtenerAlmacenTag(tagEscaneado));

    if (!almacenTag || !Array.isArray(coincidencias) || coincidencias.length === 0) {
      return null;
    }

    return (
      coincidencias.find(({ linea }) => {
        const almacenesLinea = [
          obtenerAlmacenLineaEscaneo(linea),
          obtenerAlmacenOrigen(linea),
          obtenerAlmacenDestino(linea),
          linea?.Almacen,
          linea?.WarehouseCode,
          linea?.WhsCode,
        ]
          .map((almacen) => normalizarCodigoRuta(almacen))
          .filter(Boolean);

        return almacenesLinea.includes(almacenTag);
      }) || null
    );
  };

  const seleccionarLineaDuplicadaPorAlmacen = async ({
    coincidencias = [],
    codigoEscaneado = "",
  }) => {
    if (!Array.isArray(coincidencias) || coincidencias.length === 0) {
      return null;
    }

    if (coincidencias.length === 1) {
      return coincidencias[0];
    }

    const inputOptions = coincidencias.reduce((acc, { linea, index }) => {
      const almacen = obtenerAlmacenOrigen(linea) || "-";

      acc[String(index)] = almacen;
      return acc;
    }, {});

    const respuesta = await Swal.fire({
      ...swalBase,
      icon: "question",
      title: "Seleccione el almacén",
      html: `
        <div style="text-align:left; font-size:14px; line-height:1.35;">
          El código escaneado 
          aparece en varias líneas pendientes. Seleccione cuál desea validar.
        </div>
      `,
      input: "select",
      inputOptions,
      inputPlaceholder: "Seleccione almacén",
      showCancelButton: true,
      confirmButtonText: "Validar selección",
      cancelButtonText: "Cancelar",
      allowOutsideClick: false,
      allowEscapeKey: false,
      inputValidator: (value) => {
        if (value === undefined || value === null || String(value).trim() === "") {
          return "Debe seleccionar una línea para validar.";
        }
        return null;
      },
    });

    if (!respuesta.isConfirmed) return null;

    const indexSeleccionado = Number(respuesta.value);

    return (
      coincidencias.find((item) => Number(item.index) === indexSeleccionado) ||
      null
    );
  };

  const esTeclaConfirmacionEscaner = (event) => {
    return (
      event.key === "Enter" ||
      event.key === "NumpadEnter" ||
      event.key === "Tab" ||
      event.keyCode === 13 ||
      event.which === 13
    );
  };

  const limpiarAutoEscaner = (id) => {
    clearTimeout(scannerAutoTimersRef.current[id]);
    scannerAutoStatsRef.current[id] = {
      lastTime: 0,
      previousLength: 0,
      intervals: [],
    };
  };

  const ejecutarEscaneoConfirmado = async ({ id, value, callback }) => {
    const valorFinal = String(value || "").trim();

    if (!valorFinal) return;

    const ahora = Date.now();
    const ultimo = scannerAutoUltimoProcesadoRef.current[id];

    // Evita doble ejecucion si el lector escribe rapido y ademas manda Enter.
    if (
      ultimo &&
      ultimo.valor === valorFinal &&
      ahora - ultimo.timestamp < 900
    ) {
      return;
    }

    scannerAutoUltimoProcesadoRef.current[id] = {
      valor: valorFinal,
      timestamp: ahora,
    };

    limpiarAutoEscaner(id);

    await callback(valorFinal);
  };

  const manejarConfirmacionEscaneo = async (event, callback, id = "scanner") => {
    if (!esTeclaConfirmacionEscaner(event)) return;

    event.preventDefault();
    event.stopPropagation();

    clearTimeout(scannerAutoTimersRef.current[id]);

    await ejecutarEscaneoConfirmado({
      id,
      value: event.currentTarget.value,
      callback,
    });
  };

  const registrarLecturaRapidaEscaner = ({
    id,
    value,
    setValue,
    callback,
  }) => {
    const texto = String(value || "");
    setValue(texto);

    const ahora = Date.now();

    const statsAnterior = scannerAutoStatsRef.current[id] || {
      lastTime: 0,
      previousLength: 0,
      intervals: [],
    };

    const diferenciaTiempo = statsAnterior.lastTime
      ? ahora - statsAnterior.lastTime
      : 0;

    const diferenciaCaracteres =
      texto.length - Number(statsAnterior.previousLength || 0);

    let intervals = [...(statsAnterior.intervals || [])];

    if (!texto) {
      intervals = [];
    } else if (!statsAnterior.lastTime || diferenciaTiempo > 260) {
      intervals = [];
    } else if (diferenciaCaracteres > 0) {
      intervals.push(diferenciaTiempo);
      intervals = intervals.slice(-12);
    }

    scannerAutoStatsRef.current[id] = {
      lastTime: ahora,
      previousLength: texto.length,
      intervals,
    };

    clearTimeout(scannerAutoTimersRef.current[id]);

    const promedio =
      intervals.length > 0
        ? intervals.reduce((acc, item) => acc + item, 0) / intervals.length
        : 999;

    const pareceEscanerPorVelocidad =
      texto.length >= 4 &&
      intervals.length >= 2 &&
      promedio <= 55;

    const pareceEscanerPorEntradaMasiva =
      texto.length >= 4 &&
      diferenciaCaracteres >= 3;

    if (!pareceEscanerPorVelocidad && !pareceEscanerPorEntradaMasiva) {
      return;
    }

    scannerAutoTimersRef.current[id] = window.setTimeout(() => {
      ejecutarEscaneoConfirmado({
        id,
        value: texto,
        callback,
      });
    }, 140);
  };

  const mostrarErrorAlmacenTagNoCoincide = async ({
    codigoEscaneado = "",
    almacenTag = "",
  } = {}) => {
    await Swal.fire({
      ...swalBase,
      icon: "error",
      title: "Almacén no coincide",
      html: `
        <div class="swal-barcode-error">
          <div class="swal-barcode-error-icon">
            <i class="fa-solid fa-circle-xmark" aria-hidden="true"></i>
          </div>
          <div>El código escaneado pertenece al almacén:</div>
          <strong>${escapeHtml(almacenTag || "-")}</strong>
          <div>No hay una línea pendiente con ese mismo almacén.</div>
          ${codigoEscaneado ? `<strong>${escapeHtml(codigoEscaneado)}</strong>` : ""}
        </div>
      `,
      confirmButtonText: "Entendido",
    });
  };

  const mostrarErrorCodigoNoApareceEnLista = async (codigoEscaneado) => {
    await Swal.fire({
      ...swalBase,
      icon: "error",
      title: "Código no encontrado",
      html: `
        <div class="swal-barcode-error">
          <div class="swal-barcode-error-icon">
            <i class="fa-solid fa-circle-xmark" aria-hidden="true"></i>
          </div>
          <div>El código escaneado no aparece en la lista.</div>
          ${codigoEscaneado ? `<strong>${escapeHtml(codigoEscaneado)}</strong>` : ""}
        </div>
      `,
      confirmButtonText: "Entendido",
    });
  };

  const handleEscanearRutaDocumento = async (
    value,
    tipo = "orden",
    options = {}
  ) => {
    const codigoEscaneado = String(value || "").trim();

    if (tipo === "cancelacion") {
      setCodigoRutaCancelacion("");
    } else {
      setCodigoRutaDocumento("");
    }

    if (!codigoEscaneado) return;

    const dataActual = tipo === "cancelacion" ? formDataCancelacion : formData;
    const lineas = dataActual?.DocumentLines || [];
    const tagEscaneado =
      tagsPorNumeroTag.get(normalizarCodigoRuta(codigoEscaneado)) || null;

    const coincidencias = buscarIndicesLineasPorCodigoEscaneado(
      lineas,
      codigoEscaneado
    );

    if (coincidencias.length === 0) {
      await mostrarErrorCodigoNoApareceEnLista(codigoEscaneado);
      return;
    }

    let seleccion = null;

    if (options?.autoSeleccionarPorAlmacen) {
      const almacenTag = obtenerAlmacenTag(tagEscaneado);
      seleccion = seleccionarCoincidenciaPorAlmacenTag({
        coincidencias,
        tagEscaneado,
      });

      if (almacenTag && !seleccion) {
        await mostrarErrorAlmacenTagNoCoincide({
          codigoEscaneado,
          almacenTag,
        });
        return;
      }
    }

    if (!seleccion) {
      seleccion = await seleccionarLineaDuplicadaPorAlmacen({
        coincidencias,
        codigoEscaneado,
      });
    }

    if (!seleccion) return;

    const { linea, index } = seleccion;

    actualizarEscaneoRutaLinea({
      index,
      codigo: codigoEscaneado,
      estado: "valid",
      ubicacionEscaneada:
        obtenerUbicacionLinea(linea, tagsPorItemCode) || "Validado por código escaneado",
      tipo,
    });
  };

  const handleEscanearRutaConsolidado = async (
    documentoIndex,
    value,
    options = {}
  ) => {
    const codigoEscaneado = String(value || "").trim();

    setCodigosRutaConsolidado((prev) => ({
      ...prev,
      [documentoIndex]: "",
    }));

    if (!codigoEscaneado) return;

    const documento = formDataConsolidado?.[documentoIndex];
    const lineas = documento?.DocumentLines || [];
    const tagEscaneado =
      tagsPorNumeroTag.get(normalizarCodigoRuta(codigoEscaneado)) || null;

    const coincidencias = buscarIndicesLineasPorCodigoEscaneado(
      lineas,
      codigoEscaneado
    );

    if (coincidencias.length === 0) {
      await mostrarErrorCodigoNoApareceEnLista(codigoEscaneado);
      return;
    }

    let seleccion = null;

    if (options?.autoSeleccionarPorAlmacen) {
      const almacenTag = obtenerAlmacenTag(tagEscaneado);
      seleccion = seleccionarCoincidenciaPorAlmacenTag({
        coincidencias,
        tagEscaneado,
      });

      if (almacenTag && !seleccion) {
        await mostrarErrorAlmacenTagNoCoincide({
          codigoEscaneado,
          almacenTag,
        });
        return;
      }
    }

    if (!seleccion) {
      seleccion = await seleccionarLineaDuplicadaPorAlmacen({
        coincidencias,
        codigoEscaneado,
      });
    }

    if (!seleccion) return;

    const { linea, index } = seleccion;

    actualizarEscaneoRutaLineaConsolidado({
      documentoIndex,
      lineIndex: index,
      codigo: codigoEscaneado,
      estado: "valid",
      ubicacionEscaneada:
        obtenerUbicacionLinea(linea, tagsPorItemCode) || "Validado por código escaneado",
    });
  };

  const handleEliminarLinea = async (lineaEliminar) => {
    if (!lineaEliminar) return;

    const confirmacion = await Swal.fire({
      ...swalBase,
      icon: "warning",
      title: "Eliminar línea",
      html: `¿Desea eliminar únicamente la línea del artículo <b>${escapeHtml(
        obtenerCodigoArticulo(lineaEliminar) || ""
      )}</b>?`,
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });

    if (!confirmacion.isConfirmed) return;

    setFormData((prev) => {
      if (!prev || !Array.isArray(prev.DocumentLines)) return prev;

      const clientLineIdEliminar = String(lineaEliminar.ClientLineId || "");
      const baseLineEliminar = Number(
        lineaEliminar.BaseLine ?? lineaEliminar.LineNum
      );

      let lineaEliminada = false;
      const updatedLines = prev.DocumentLines.filter((linea) => {
        if (lineaEliminada) return true;

        const clientLineIdActual = String(linea.ClientLineId || "");
        const baseLineActual = Number(linea.BaseLine ?? linea.LineNum);

        const coincidePorId =
          clientLineIdEliminar && clientLineIdActual === clientLineIdEliminar;
        const coincidePorBaseLine =
          !clientLineIdEliminar &&
          !Number.isNaN(baseLineEliminar) &&
          baseLineActual === baseLineEliminar;

        if (coincidePorId || coincidePorBaseLine) {
          lineaEliminada = true;
          return false;
        }

        return true;
      });

      return {
        ...prev,
        ...actualizarResumenEnEstado(updatedLines),
      };
    });
  };


  const validarDocumentoEntrega = (documento, incluirDocNum = false) => {
    if (!documento || !Array.isArray(documento.DocumentLines)) {
      return {
        ok: false,
        message: incluirDocNum
          ? `Documento ${documento?.DocNum || ""}: no hay información para procesar.`
          : "No hay información para procesar la entrega.",
      };
    }

    const prefijo = incluirDocNum ? `Documento ${documento.DocNum || ""}: ` : "";

    const lineaAgrupadaConExceso = (documento.DocumentLines || []).find(
      (linea) => Number(linea.Quantity || 0) > Number(linea.OpenQuantity || 0)
    );

    if (lineaAgrupadaConExceso) {
      return {
        ok: false,
        icon: "error",
        title: "Cantidad inválida",
        message: `${prefijo}la cantidad agrupada del artículo ${obtenerCodigoArticulo(lineaAgrupadaConExceso) || ""} no puede ser mayor a la cantidad pendiente agrupada.`,
      };
    }

    const lineasDocumento = documento.EsDocumentoConsolidado || incluirDocNum
      ? expandirLineasConsolidadasParaSAP(documento.DocumentLines)
      : documento.DocumentLines;
    const lineasFinales = recalcularLineasConIva(lineasDocumento);

    const lineasConCantidad = lineasFinales.filter(
      (linea) => !lineaEstaCerrada(linea) && Number(linea.Quantity || 0) > 0
    );

    if (lineasConCantidad.length === 0) {
      return {
        ok: false,
        icon: "warning",
        title: "Sin cantidades",
        message: `${prefijo}debe ingresar al menos una línea abierta con cantidad mayor a 0.`,
      };
    }

    const lineaSinEscaneoRutaValido = lineasConCantidad.find(
      (linea) => linea.RutaScanStatus !== "valid"
    );

    if (lineaSinEscaneoRutaValido) {
      return {
        ok: false,
        icon: "error",
        title: "Código escaneado incorrecto",
        message: `${prefijo}debe escanear correctamente la ruta del artículo ${obtenerCodigoArticulo(lineaSinEscaneoRutaValido) || ""} antes de crear la entrega.`,
      };
    }

    const lineaInvalida = lineasConCantidad.find(
      (linea) => Number(linea.Quantity || 0) > Number(linea.OpenQuantity || 0)
    );

    if (lineaInvalida) {
      return {
        ok: false,
        icon: "error",
        title: "Cantidad inválida",
        message: `${prefijo}la cantidad del artículo ${obtenerCodigoArticulo(lineaInvalida) || ""} no puede ser mayor a la cantidad pendiente.`,
      };
    }

    const lineaSinAlmacen = lineasConCantidad.find(
      (linea) => !String(obtenerAlmacenDestino(linea)).trim()
    );

    if (lineaSinAlmacen) {
      return {
        ok: false,
        icon: "warning",
        title: "Almacén requerido",
        message: `${prefijo}debe seleccionar un almacén para el artículo ${obtenerCodigoArticulo(lineaSinAlmacen) || ""}.`,
      };
    }

    return {
      ok: true,
      lineasConCantidad,
    };
  };

  const separarLineasConsolidadoPorDocumentoOrigen = (lineas = [], documentoConsolidado = {}) => {
    const lineasExpandidas = expandirLineasConsolidadasParaSAP(lineas);
    const gruposPorDocumento = new Map();
    const documentosOrigen = new Map(
      (documentoConsolidado.DocumentosOrigen || []).map((documento) => [
        String(documento.DocEntry || ""),
        documento,
      ])
    );

    lineasExpandidas.forEach((linea) => {
      const docEntryOrigen = String(linea.DocEntryOrigen || linea.DocEntry || "").trim();
      if (!docEntryOrigen) return;

      const documentoOrigen = documentosOrigen.get(docEntryOrigen) || {};

      if (!gruposPorDocumento.has(docEntryOrigen)) {
        gruposPorDocumento.set(docEntryOrigen, {
          ...documentoOrigen,
          DocEntry: linea.DocEntryOrigen || linea.DocEntry || documentoOrigen.DocEntry,
          DocNum: linea.DocNumOrigen || documentoOrigen.DocNum || "",
          DocDate: linea.DocDateOrigen || documentoOrigen.DocDate || null,
          TaxDate: linea.TaxDateOrigen || documentoOrigen.TaxDate || null,
          CommentsBase: linea.CommentsBaseOrigen || documentoOrigen.CommentsBase || documentoConsolidado.CommentsBase || "",
          Copies: obtenerCantidadCopiasDocumento(documentoConsolidado),
          EsDocumentoConsolidado: false,
          DocumentLines: [],
        });
      }

      gruposPorDocumento.get(docEntryOrigen).DocumentLines.push({
        ...linea,
        DocEntry: linea.DocEntryOrigen || linea.DocEntry,
      });
    });

    return Array.from(gruposPorDocumento.values());
  };

  const crearEntregaDesdeDocumento = async (documento, lineasConCantidad) => {
    const comentariosFinales = construirComentariosEntrega({
      usuario: nombreApellidoLogueado,
      comments: documento.CommentsBase,
    });

    const payload = {
      DocDate: documento.DocDate || null,
      TaxDate: documento.TaxDate || null,
      Comments: comentariosFinales,
      DocumentLines: lineasConCantidad.map((linea) => ({
        BaseType: 17,
        BaseEntry: Number(documento.DocEntry),
        BaseLine: obtenerNumeroLineaBase(linea, 0),
        Quantity: Number(linea.Quantity || 0),
        WarehouseCode: obtenerAlmacenDestino(linea),
        ItemCode: obtenerCodigoArticulo(linea),
      })),
    };

    const res = await fetch(API_URL_CREAR_ENTREGA, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "API-Key": API_KEY,
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (!res.ok || data.answer !== "true") {
      throw new Error(data.message || "No fue posible crear la entrega.");
    }

    const docNumCreado =
      data.doc_num ||
      data.DocNum ||
      data.docNum ||
      extraerDocNumCreadoRespuesta(data.message) ||
      "";

    return {
      data,
      docNumCreado,
      comentariosFinales,
    };
  };

  const handleGuardarConsolidado = async () => {
    try {
      if (!Array.isArray(formDataConsolidado) || formDataConsolidado.length === 0) {
        Swal.fire({
          ...swalBase,
          icon: "error",
          title: "Sin documentos",
          text: "No hay documentos para procesar.",
        });
        return;
      }

      const documentoConsolidado = formDataConsolidado[0];
      const validacionConsolidado = validarDocumentoEntrega(documentoConsolidado, true);

      if (!validacionConsolidado.ok) {
        Swal.fire({
          ...swalBase,
          icon: validacionConsolidado.icon || "error",
          title: validacionConsolidado.title || "Validación pendiente",
          text: validacionConsolidado.message,
        });
        return;
      }

      const documentosIndividuales = separarLineasConsolidadoPorDocumentoOrigen(
        documentoConsolidado.DocumentLines || [],
        documentoConsolidado
      );

      if (documentosIndividuales.length === 0) {
        Swal.fire({
          ...swalBase,
          icon: "error",
          title: "Sin documentos origen",
          text: "No fue posible separar el consolidado por documentos origen.",
        });
        return;
      }

      const documentosValidados = [];

      for (const documento of documentosIndividuales) {
        const validacion = validarDocumentoEntrega(documento, true);

        if (!validacion.ok) {
          Swal.fire({
            ...swalBase,
            icon: validacion.icon || "error",
            title: validacion.title || "Validación pendiente",
            text: validacion.message,
          });
          return;
        }

        documentosValidados.push({
          documento,
          lineasConCantidad: validacion.lineasConCantidad,
        });
      }

      const confirmacion = await Swal.fire({
        ...swalBase,
        icon: "question",
        title: "Confirmar consolidado",
        text: `Se mostrara 1 consolidado agrupado por codigo y se crearan ${documentosValidados.length} entregas individuales. ¿Desea continuar?`,
        showCancelButton: true,
        confirmButtonText: "Sí, procesar",
        cancelButtonText: "Cancelar",
      });

      if (!confirmacion.isConfirmed) return;

      setProcesandoConsolidado(true);

      Swal.fire({
        ...swalBase,
        title: "Procesando consolidado",
        text: "Creando entregas de forma individual...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const resultados = [];

      for (const item of documentosValidados) {
        const { documento, lineasConCantidad } = item;
        const resultado = await crearEntregaDesdeDocumento(documento, lineasConCantidad);

        resultados.push({
          orden: documento.DocNum,
          entrega: resultado.docNumCreado,
          copies: obtenerCantidadCopiasDocumento(documentoConsolidado),
          documento,
          lineasConCantidad,
          comentariosFinales: resultado.comentariosFinales,
        });
      }

      Swal.close();

      for (let index = 0; index < resultados.length; index += 1) {
        const item = resultados[index];
        const siguienteItem = resultados[index + 1];

        await imprimirEntregaTermicaSecuencial({
          logoUrl: LOGO_TICKET,
          docNum: item.entrega,
          formData: {
            ...item.documento,
            DocumentLines: (item.lineasConCantidad || [])
              .filter((linea) => Number(linea.Quantity || 0) > 0)
              .map((linea) => ({
                ...linea,
                Ubicacion: obtenerUbicacionLinea(linea, tagsPorItemCode),
              })),
            Comments: item.comentariosFinales,
          },
          copies: item.copies,
          pausarDespuesUltimaCopia: Boolean(siguienteItem),
          siguienteDocumentoTexto: siguienteItem
            ? `la orden ${siguienteItem.orden || ""}`
            : "el siguiente documento",
        });
      }

      await Swal.fire({
        ...swalBase,
        icon: "success",
        title: "Consolidado procesado",
        html: resultados
          .map(
            (item) =>
              `<div>Orden <b>${escapeHtml(item.orden)}</b> → Entrega <b>${escapeHtml(item.entrega)}</b> | Copias: <b>${escapeHtml(item.copies)}</b></div>`
          )
          .join(""),
      });

      cerrarModalConsolidadoSinConfirmar();
      limpiarSeleccionOrdenesConsolidado();
      fetchOrdenesVenta();
      fetchEntregasCancelacion();
    } catch (err) {
      console.error(err);
      Swal.close();

      Swal.fire({
        ...swalBase,
        icon: "error",
        title: "Error en consolidado",
        text: err.message || "Ocurrió un error al procesar el consolidado.",
      });
    } finally {
      setProcesandoConsolidado(false);
    }
  };

  const handleGuardar = async () => {
    try {
      if (!formData || !Array.isArray(formData.DocumentLines)) {
        Swal.fire({
          ...swalBase,
          icon: "error",
          title: "Error",
          text: "No hay información para procesar la entrega.",
        });
        return;
      }

      // Se procesan únicamente las líneas que continúan visibles en el estado.
      // Una línea eliminada ya no puede volver a incluirse en el payload.
      const lineasConCantidad = recalcularLineasConIva(
        formData.DocumentLines
      ).filter(
        (linea) => !lineaEstaCerrada(linea) && Number(linea.Quantity || 0) > 0
      );

      if (lineasConCantidad.length === 0) {
        Swal.fire({
          ...swalBase,
          icon: "warning",
          title: "Sin cantidades",
          text: "Debe ingresar al menos una línea abierta con cantidad mayor a 0.",
        });
        return;
      }

      const lineaSinEscaneoRutaValido = lineasConCantidad.find(
        (linea) => linea.RutaScanStatus !== "valid"
      );

      if (lineaSinEscaneoRutaValido) {
        Swal.fire({
          ...swalBase,
          icon: "error",
          title: "Código escaneado incorrecto",
          text: `Debe escanear correctamente la ruta del artículo ${obtenerCodigoArticulo(lineaSinEscaneoRutaValido) || ""} antes de crear la entrega.`,
        });
        return;
      }

      const lineaInvalida = lineasConCantidad.find(
        (linea) => Number(linea.Quantity || 0) > Number(linea.OpenQuantity || 0)
      );

      if (lineaInvalida) {
        Swal.fire({
          ...swalBase,
          icon: "error",
          title: "Cantidad inválida",
          text: `La cantidad del artículo ${lineaInvalida.ItemCode || ""} no puede ser mayor a la cantidad pendiente.`,
        });
        return;
      }

      const lineaSinAlmacen = lineasConCantidad.find(
        (linea) => !String(obtenerAlmacenDestino(linea)).trim()
      );

      if (lineaSinAlmacen) {
        Swal.fire({
          ...swalBase,
          icon: "warning",
          title: "Almacén requerido",
          text: `Debe seleccionar un almacén para el artículo ${lineaSinAlmacen.ItemCode || ""}.`,
        });
        return;
      }

      const comentariosFinales = construirComentariosEntrega({
        usuario: nombreApellidoLogueado,
        comments: formData.CommentsBase,
      });

      const payload = {
        DocDate: formData.DocDate || null,
        TaxDate: formData.TaxDate || null,
        Comments: comentariosFinales,
        DocumentLines: lineasConCantidad.map((linea) => ({
          BaseType: 17,
          BaseEntry: Number(formData.DocEntry),
          BaseLine: Number(linea.BaseLine ?? linea.LineNum),
          Quantity: Number(linea.Quantity || 0),
          WarehouseCode: obtenerAlmacenDestino(linea),
          ItemCode: obtenerCodigoArticulo(linea),
        })),
      };

      const confirmacion = await Swal.fire({
        ...swalBase,
        icon: "question",
        title: "Confirmar entrega",
        text: "¿Desea crear la entrega con las cantidades indicadas?",
        showCancelButton: true,
        confirmButtonText: "Sí, crear",
        cancelButtonText: "Cancelar",
      });

      if (!confirmacion.isConfirmed) return;

      Swal.fire({
        ...swalBase,
        title: "Creando entrega",
        text: "Por favor espere...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const res = await fetch(API_URL_CREAR_ENTREGA, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "API-Key": API_KEY,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      Swal.close();

      if (!res.ok || data.answer !== "true") {
        throw new Error(data.message || "No fue posible crear la entrega.");
      }

      await Swal.fire({
        ...swalBase,
        icon: "success",
        title: "Proceso exitoso",
        text: data.message || "Entrega creada correctamente.",
        confirmButtonText: "Imprimir",
      });

      const docNumCreado = data.doc_num || data.DocNum || data.docNum || extraerDocNumCreadoRespuesta(data.message) || "";

      await imprimirEntregaTermicaSecuencial({
        logoUrl: LOGO_TICKET,
        docNum: docNumCreado,
        formData: {
          ...formData,
          DocumentLines: lineasConCantidad.map((linea) => ({
            ...linea,
            Ubicacion: obtenerUbicacionLinea(linea, tagsPorItemCode),
          })),
          Comments: comentariosFinales,
        },
      });

      cerrarModalOrdenSinConfirmar();
      fetchOrdenesVenta();
    } catch (err) {
      console.error(err);
      Swal.close();

      Swal.fire({
        ...swalBase,
        icon: "error",
        title: "Error al crear entrega",
        text: err.message || "Ocurrió un error al crear la entrega.",
      });
    }
  };

  const handleCommentsCancelacionChange = (value) => {
    setFormDataCancelacion((prev) =>
      prev
        ? {
            ...prev,
            CommentsBase: value,
          }
        : prev
    );
  };

  const handleDocNumReimpresionChange = (value) => {
    const limpio = String(value || "").replace(/[^0-9]/g, "");
    setDocNumReimpresion(limpio);
  };

  const handleReimprimirEntrega = async () => {
    const docNumBuscado = String(docNumReimpresion || "").trim();

    if (!docNumBuscado) {
      Swal.fire({
        ...swalBase,
        icon: "warning",
        title: "Número requerido",
        text: "Ingrese el número de documento de la entrega que desea reimprimir.",
      });
      return;
    }

    const docEntry = obtenerDocEntryPorDocNumEntrega(docNumBuscado);

    if (!docEntry) {
      Swal.fire({
        ...swalBase,
        icon: "error",
        title: "Documento no encontrado",
        text: `No se encontró una entrega con DocNum ${docNumBuscado}.`,
      });
      return;
    }

    try {
      setProcesandoReimpresion(true);

      Swal.fire({
        ...swalBase,
        title: "Cargando entrega",
        text: "Buscando detalle para reimpresión...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const res = await fetch(`${API_URL_DETALLE_ENTREGA}/${docEntry}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "API-Key": API_KEY,
        },
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Error ${res.status}: ${text}`);
      }

      const data = await res.json();

      if (data.answer !== "true") {
        throw new Error(data.message || "Error al obtener el detalle de la entrega.");
      }

      const detalle = normalizarDocumentoConLineas(data.data);
      const documentLinesBase = Array.isArray(detalle?.DocumentLines)
        ? detalle.DocumentLines.map((linea, index) =>
            construirLineaDesdeDetalle(linea, index, false)
          )
        : [];
      const documentLines = await enriquecerLineasConStockOrigen(documentLinesBase);
      const formDataReimpresion = construirFormDataReimpresionEntrega(
        detalle,
        documentLines
      );

      Swal.close();

      const confirmacion = await Swal.fire({
        ...swalBase,
        icon: "question",
        title: "Confirmar reimpresión",
        text: `Se imprimirán 3 copias de la entrega ${formDataReimpresion.DocNum || docNumBuscado}. ¿Desea continuar?`,
        showCancelButton: true,
        confirmButtonText: "Sí, imprimir",
        cancelButtonText: "Cancelar",
      });

      if (!confirmacion.isConfirmed) return;

      await imprimirEntregaTermicaSecuencial({
        logoUrl: LOGO_TICKET,
        docNum: formDataReimpresion.DocNum || docNumBuscado,
        formData: {
          ...formDataReimpresion,
          DocumentLines: (formDataReimpresion.DocumentLines || [])
            .filter((linea) => Number(linea.Quantity || 0) > 0)
            .map((linea) => ({
              ...linea,
              Ubicacion: obtenerUbicacionLinea(linea, tagsPorItemCode),
            })),
          Comments: formDataReimpresion.Comments || formDataReimpresion.CommentsBase || "",
        },
        copyLabel: "ENTREGA",
        copies: 3,
      });

      await Swal.fire({
        ...swalBase,
        icon: "success",
        title: "Reimpresión finalizada",
        text: `Entrega ${formDataReimpresion.DocNum || docNumBuscado} reimpresa correctamente.`,
      });

      setDocNumReimpresion("");
    } catch (err) {
      console.error(err);
      Swal.close();

      Swal.fire({
        ...swalBase,
        icon: "error",
        title: "Error al reimprimir",
        text: err.message || "Ocurrió un error al reimprimir la entrega.",
      });
    } finally {
      setProcesandoReimpresion(false);
    }
  };

  const cerrarModalCancelacionSinConfirmar = () => {
    setModalCancelacionOpen(false);
    setDetalleEntregaCancelacion(null);
    setFormDataCancelacion(null);
    setErrorDetalleCancelacion("");
  };

  const closeModalCancelacion = async () => {
    const confirmado = await confirmarCierreModal({
      title: "¿Cerrar detalle de entrega?",
      text: "Si cierra este modal, perderá la información cargada de la cancelación.",
    });

    if (!confirmado) return;

    cerrarModalCancelacionSinConfirmar();
  };

  const handleCancelarEntregaStock = async () => {
    try {
      if (!formDataCancelacion?.DocEntry) {
        Swal.fire({
          ...swalBase,
          icon: "error",
          title: "Error",
          text: "No hay una entrega seleccionada para cancelar.",
        });
        return;
      }

      const confirmacion = await Swal.fire({
        ...swalBase,
        icon: "warning",
        title: "Confirmar cancelación",
        text: `¿Desea cancelar la entrega ${formDataCancelacion.DocNum || ""}?`,
        showCancelButton: true,
        confirmButtonText: "Sí, cancelar",
        cancelButtonText: "No cancelar",
      });

      if (!confirmacion.isConfirmed) return;

      Swal.fire({
        ...swalBase,
        title: "Cancelando entrega",
        text: "Por favor espere...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const res = await fetch(
        API_URL_CANCELAR_ENTREGA_STOCK(formDataCancelacion.DocEntry),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "API-Key": API_KEY,
          },
        }
      );

      const data = await res.json().catch(() => ({}));

      Swal.close();

      if (!res.ok || data.answer !== "true") {
        throw new Error(
          data.message || "No fue posible cancelar la entrega."
        );
      }

      const comentariosFinales = construirComentariosEntrega({
        usuario: nombreApellidoLogueado,
        comments: formDataCancelacion.CommentsBase,
      });

      await Swal.fire({
        ...swalBase,
        icon: "success",
        title: "Cancelación exitosa",
        text: data.message || "Entrega cancelada correctamente.",
        confirmButtonText: "Imprimir",
      });

      await imprimirEntregaTermicaSecuencial({
        logoUrl: LOGO_TICKET,
        docNum: formDataCancelacion.DocNum || "",
        formData: {
          ...formDataCancelacion,
          DocumentLines: (formDataCancelacion.DocumentLines || []).map((linea) => ({
            ...linea,
            Ubicacion: obtenerUbicacionLinea(linea, tagsPorItemCode),
          })),
          Comments: comentariosFinales,
        },
        copyLabel: "CANCELADO",
      });

      cerrarModalCancelacionSinConfirmar();
      fetchEntregasCancelacion();
      fetchOrdenesVenta();
    } catch (err) {
      console.error(err);
      Swal.close();

      Swal.fire({
        ...swalBase,
        icon: "error",
        title: "Error al cancelar entrega",
        text: err.message || "Ocurrió un error al cancelar la entrega.",
      });
    }
  };

  const cerrarModalOrdenSinConfirmar = () => {
    setModalOpen(false);
    setDetalleOrdenVenta(null);
    setFormData(null);
    setErrorDetalle("");
  };

  const closeModal = async () => {
    const confirmado = await confirmarCierreModal({
      title: "¿Cerrar detalle de orden?",
      text: "Si cierra este modal, perderá la información cargada de la entrega.",
    });

    if (!confirmado) return;

    cerrarModalOrdenSinConfirmar();
  };

  return (
    <div className="entrega-stock-container">
      <header className="entrega-stock-header">
        <div>
          <h1>Órdenes de Venta</h1>
          <p>Seleccione una orden de venta abierta</p>
        </div>
      </header>

      {!loading && !error && (
        <>
          <section className="orden-compra-combo-section">
            <div className="orden-compra-combo-wrapper" ref={ordenSearchRef}>
              <label className="orden-compra-label">
                Buscar Orden de Venta para Entrega
              </label>

              <input
                type="text"
                className="orden-compra-input"
                autoComplete="off"
                placeholder="Buscar por # Documento..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setShowOptions(true);
                }}
                onFocus={() => setShowOptions(true)}
              />

              {showOptions && (
                <div className="orden-compra-options">
                  {filteredOrdenesVenta.length > 0 ? (
                    filteredOrdenesVenta.map((orden) => (
                      <div
                        key={orden.DocEntry}
                        className={`orden-compra-option ${ordenesSeleccionadasIds.has(String(orden.DocEntry || "")) ? "orden-compra-option-selected" : ""}`}
                        onClick={() => handleSelectOrdenVenta(orden)}
                      >
                        <span>{orden.DocNum}</span>
                        {modoConsolidado && ordenesSeleccionadasIds.has(String(orden.DocEntry || "")) && (
                          <strong>Seleccionado</strong>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className="orden-compra-option-empty">
                      No se encontraron resultados
                    </div>
                  )}
                </div>
              )}
            </div>
          </section>

          <section className="orden-compra-combo-section consolidado-section">
            <div className="consolidado-toolbar">
              <button
                type="button"
                className={`btn-consolidado-toggle ${modoConsolidado ? "btn-consolidado-toggle-active" : ""}`}
                onClick={() => {
                  setModoConsolidado((prev) => !prev);
                  setShowOptions(false);
                }}
              >
                {modoConsolidado ? "Modo consolidado activo" : "Activar consolidado móvil"}
              </button>

              {modoConsolidado && (
                <button
                  type="button"
                  className="btn-consolidado-limpiar"
                  onClick={limpiarSeleccionOrdenesConsolidado}
                  disabled={ordenesSeleccionadas.length === 0}
                >
                  Limpiar selección
                </button>
              )}
            </div>

            {modoConsolidado && (
              <div className="consolidado-panel">
                <div className="consolidado-panel-header">
                  <div>
                    <h3>Consolidado móvil</h3>
                    <p>
                      Seleccione varias ordenes. Cada una se validará, creará e imprimirá de forma individual.
                    </p>
                  </div>
                  <span className="consolidado-count">
                    {ordenesSeleccionadas.length} seleccionado(s)
                  </span>
                </div>

                {ordenesSeleccionadas.length > 0 ? (
                  <div className="consolidado-selected-list">
                    {ordenesSeleccionadas.map((orden) => (
                      <div key={orden.DocEntry} className="consolidado-selected-item">
                        <span>Orden #{orden.DocNum}</span>
                        <button
                          type="button"
                          onClick={() => toggleOrdenConsolidado(orden)}
                        >
                          Quitar
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="consolidado-empty">
                    Busque y toque las ordenes para agregarlas al consolidado.
                  </div>
                )}

                <button
                  type="button"
                  className="btn-primary btn-procesar-consolidado"
                  onClick={abrirConsolidado}
                  disabled={ordenesSeleccionadas.length === 0}
                >
                  Preparar consolidado
                </button>
              </div>
            )}
          </section>

          <section className="orden-compra-combo-section">
            <div className="orden-compra-combo-wrapper" ref={cancelacionSearchRef}>
              <label className="orden-compra-label">
                Buscar Entrega para cancelación
              </label>

              <input
                type="text"
                className="orden-compra-input"
                autoComplete="off"
                placeholder="Buscar entrega por # Documento..."
                value={searchCancelacion}
                onChange={(e) => {
                  setSearchCancelacion(e.target.value);
                  setShowOptionsCancelacion(true);
                }}
                onFocus={() => setShowOptionsCancelacion(true)}
              />

              {showOptionsCancelacion && (
                <div className="orden-compra-options">
                  {filteredEntregasCancelacion.length > 0 ? (
                    filteredEntregasCancelacion.map((entrega) => (
                      <div
                        key={entrega.DocEntry}
                        className="orden-compra-option"
                        onClick={() => handleSelectEntregaCancelacion(entrega)}
                      >
                        {entrega.DocNum}
                      </div>
                    ))
                  ) : (
                    <div className="orden-compra-option-empty">
                      No se encontraron entregas
                    </div>
                  )}
                </div>
              )}
            </div>
          </section>

          <section className="orden-compra-combo-section">
            <div className="orden-compra-combo-wrapper">
              <label className="orden-compra-label">
                Reimprimir Entrega
              </label>

              <div className="consolidado-toolbar">
                <input
                  type="text"
                  className="orden-compra-input"
                  inputMode="numeric"
                  autoComplete="off"
                  placeholder="Ingrese DocNum de la entrega..."
                  value={docNumReimpresion}
                  disabled={procesandoReimpresion}
                  onChange={(e) => handleDocNumReimpresionChange(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleReimprimirEntrega();
                    }
                  }}
                />

                <button
                  type="button"
                  className="btn-primary"
                  onClick={handleReimprimirEntrega}
                  disabled={procesandoReimpresion || !String(docNumReimpresion || "").trim()}
                >
                  {procesandoReimpresion ? "Imprimiendo..." : "Imprimir"}
                </button>
              </div>

              <p className="modal-subtitle">
                Ingrese el DocNum. El sistema buscará su DocEntry y reimprimirá 3 copias con pausa entre cada una.
              </p>
            </div>
          </section>


        </>
      )}

      {modalOpen && formData && (
        <div className="modal-overlay" onClick={closeModal}>
          <div
            className="modal-content modal-orden-compra"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <div className="modal-header-text">
                <h2>Detalle Orden de Venta</h2>
                <p className="modal-subtitle">
                  DocNum: {formData.DocNum} | Orden de venta
                </p>
              </div>

              <button className="modal-close-btn" onClick={closeModal}>
                ×
              </button>
            </div>

            <div className="modal-body">
              <div className="modal-section">
                <h3 className="modal-section-title">Datos de encabezado</h3>

                <div className="orden-header-grid">
                  <div className="form-field form-field-sm">
                    <label className="form-label"># Documento</label>
                    <div className="form-value form-readonly">{formData.DocNum}</div>
                  </div>


                  <div className="form-field form-field-sm">
                    <label className="form-label">Fecha de Contabilización</label>
                    <input
                      className="form-date"
                      type="date"
                      value={formData.TaxDate}
                      onChange={(e) => handleHeaderChange("TaxDate", e.target.value)}
                    />
                  </div>

                  <div className="form-field form-field-sm">
                    <label className="form-label">Fecha de Vencimiento</label>
                    <input
                      className="form-date"
                      type="date"
                      value={formData.DocDueDate}
                      onChange={(e) => handleHeaderChange("DocDueDate", e.target.value)}
                    />
                  </div>

                  <div className="form-field form-field-sm">
                    <label className="form-label">Fecha de Documento</label>
                    <input
                      className="form-date"
                      type="date"
                      value={formData.DocDate}
                      onChange={(e) => handleHeaderChange("DocDate", e.target.value)}
                    />
                  </div>


                </div>
              </div>

              <div className="modal-section">
                <h3 className="modal-section-title">Líneas de la orden</h3>

                <div className="lines-table-wrapper lines-card-wrapper">
                  <div className="lines-table lines-card-table">
                    <div className="lines-header">
                      <span className="col-numero-linea">No.</span>
                      <span className="col-accion">Acción</span>
                      <span>Código</span>
                      <span className="col-descripcion">Descripción</span>
                      <span>Ubicación</span>
                      <span>Stock</span>
                      <span>Cantidad</span>
                      <span>Pendiente</span>
                      <span>Almacén</span>
                    </div>

                    {Array.isArray(formData.DocumentLines) &&
                    formData.DocumentLines.length > 0 ? (
                      formData.DocumentLines.map((linea, index) => {
                        const isClosed =
                          linea.IsClosedLine || Number(linea.OpenQuantity || 0) <= 0;

                        return (
                          <div
                            key={linea.ClientLineId || `${formData.DocEntry}-${linea.LineNum}-${index}`}
                            className={`lines-row ${isClosed ? "lines-row-closed" : ""} ${linea.RutaScanStatus === "valid" ? "ruta-card-valid" : ""}`}
                          >
                            <span
                              className="line-text line-numero mobile-card-no"
                              data-label="No."
                            >
                              {index + 1}
                            </span>

                            <div
                              className="cell-accion mobile-card-accion"
                              data-label="Acción"
                            >
                              <button
                                type="button"
                                className="btn-eliminar-linea"
                                onClick={() => handleEliminarLinea(linea)}
                              >
                                Eliminar
                              </button>
                            </div>

                            <span
                              className="line-text cell-codigo mobile-card-codigo"
                              data-label="Código"
                              title={obtenerCodigoArticulo(linea) || "-"}
                            >
                              {obtenerCodigoArticulo(linea) || "-"}
                            </span>

                            <span
                              className="line-text cell-descripcion mobile-card-descripcion"
                              data-label="Descripción"
                            >
                              {obtenerDescripcionArticulo(linea) || "-"}
                            </span>

                            <span
                              className="line-text mobile-card-ubicacion"
                              data-label="Ubicación"
                            >
                              {obtenerUbicacionLinea(linea, tagsPorItemCode) || "-"}
                            </span>

                            <span
                              className="line-text mobile-card-stock"
                              data-label="Stock"
                            >
                              {obtenerStockAlmacenOrigen(linea) || "-"}
                            </span>

                            <div
                              className="line-card-input-field mobile-card-cantidad"
                              data-label="Cantidad"
                            >
                              <input
                                className={`line-input ${isClosed ? "line-input-closed" : ""}`}
                                type="text"
                                inputMode="decimal"
                                autoComplete="off"
                                value={getEditableDecimalValue(linea, "Quantity")}
                                disabled={isClosed}
                                onFocus={(e) => e.target.select()}
                                onChange={(e) =>
                                  handleLineChange(index, "Quantity", e.target.value)
                                }
                                onBlur={() => handleLineInputBlur(index, "Quantity")}
                              />
                            </div>

                            <span
                              className="line-text mobile-card-pendiente"
                              data-label="Pendiente"
                            >
                              {formatMoney2(
                                linea.OpenQuantity != null ? linea.OpenQuantity : 0
                              )}
                            </span>

                            <div
                              className="line-card-input-field mobile-card-origen"
                              data-label="Almacén"
                            >
                              <input
                                className="line-input line-input-closed"
                                type="text"
                                value={obtenerAlmacenOrigen(linea) || "-"}
                                disabled
                                readOnly
                              />
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="lines-row lines-row-empty">
                        <span className="line-text" data-label="Detalle">
                          No hay líneas para mostrar
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="modal-section">
                <div className="orden-footer-grid">
                  <div className="form-field form-field-comments">
                    <label className="form-label">Comentario</label>
                    <textarea
                      className="form-textarea"
                      autoComplete="off"
                      autoCorrect="off"
                      value={comentarioCompleto}
                      onChange={(e) => handleCommentsChange(e.target.value)}
                    />
                  </div>

                </div>
              </div>

              <div className="modal-actions modal-actions-with-scanner">
                <div className="scanner-action-field">
                  <label className="scanner-action-label">Escanear código</label>
                  <input
                    className="scanner-action-input"
                    type="text"
                    inputMode="text"
                    autoComplete="off"
                    autoCorrect="off"
                    placeholder="Escanee código de ruta o artículo"
                    value={codigoRutaDocumento}
                    onChange={(e) =>
                      registrarLecturaRapidaEscaner({
                        id: "orden",
                        value: e.target.value,
                        setValue: setCodigoRutaDocumento,
                        callback: (value) =>
                          handleEscanearRutaDocumento(value, "orden", {
                            autoSeleccionarPorAlmacen: true,
                          }),
                      })
                    }
                    onKeyDown={(e) =>
                      manejarConfirmacionEscaneo(
                        e,
                        (value) => handleEscanearRutaDocumento(value, "orden"),
                        "orden"
                      )
                    }
                  />
                </div>
                <button type="button" className="btn-secondary" onClick={closeModal}>
                  Cancelar
                </button>
                <button type="button" className="btn-primary" onClick={handleGuardar}>
                  Realizar Entrega
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {modalConsolidadoOpen && Array.isArray(formDataConsolidado) && (
        <div className="modal-overlay" onClick={closeModalConsolidado}>
          <div
            ref={modalConsolidadoContentRef}
            className="modal-content modal-orden-compra modal-consolidado"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <div className="modal-header-text">
                <h2>Consolidado de Ordenes</h2>
                <p className="modal-subtitle">
                  {formDataConsolidado.length} documento(s) seleccionados | Se crearán entregas individuales
                </p>
              </div>

              <button className="modal-close-btn" onClick={closeModalConsolidado} disabled={procesandoConsolidado}>
                ×
              </button>
            </div>

            <div className="modal-body">
              {formDataConsolidado.map((documento, documentoIndex) => (
                <div className="modal-section consolidado-documento" key={`${documento.DocEntry}-${documentoIndex}`}>
                  <div className="consolidado-documento-header">
                    <div>
                      <h3 className="modal-section-title">Orden #{documento.DocNum}</h3>
                      <p>Revise cantidades, fechas, comentarios y escaneo de rutas antes de procesar.</p>
                    </div>
                    <span>{documento.DocumentLines?.length || 0} línea(s)</span>
                  </div>

                  <div className="orden-header-grid consolidado-header-grid">
                    <div className="form-field form-field-sm">
                      <label className="form-label"># Documento</label>
                      <div className="form-value form-readonly">{documento.DocNum}</div>
                    </div>

                    <div className="form-field form-field-sm">
                      <label className="form-label">Fecha de Contabilización</label>
                      <input
                        className="form-date"
                        type="date"
                        value={documento.TaxDate}
                        onChange={(e) => handleHeaderConsolidadoChange(documentoIndex, "TaxDate", e.target.value)}
                      />
                    </div>

                    <div className="form-field form-field-sm">
                      <label className="form-label">Fecha de Vencimiento</label>
                      <input
                        className="form-date"
                        type="date"
                        value={documento.DocDueDate}
                        onChange={(e) => handleHeaderConsolidadoChange(documentoIndex, "DocDueDate", e.target.value)}
                      />
                    </div>

                    <div className="form-field form-field-sm">
                      <label className="form-label">Fecha de Documento</label>
                      <input
                        className="form-date"
                        type="date"
                        value={documento.DocDate}
                        onChange={(e) => handleHeaderConsolidadoChange(documentoIndex, "DocDate", e.target.value)}
                      />
                    </div>

                    <div className="form-field form-field-sm">
                      <label className="form-label">Copias a imprimir</label>
                      <input
                        className="form-input"
                        type="text"
                        inputMode="numeric"
                        autoComplete="off"
                        value={documento.Copies ?? ""}
                        onChange={(e) =>
                          handleCopiesConsolidadoChange(documentoIndex, e.target.value)
                        }
                        onBlur={() => handleCopiesConsolidadoBlur(documentoIndex)}
                        placeholder="1 a 3"
                      />
                    </div>
                  </div>

                  <div className="lines-table-wrapper lines-card-wrapper consolidado-lines-wrapper">
                    <div className="lines-table lines-card-table">
                      <div className="lines-header">
                        <span className="col-numero-linea">No.</span>
                        <span className="col-accion">Acción</span>
                        <span>Código</span>
                        <span className="col-descripcion">Descripción</span>
                        <span>Ubicación</span>
                        <span>Stock</span>
                        <span>Cantidad</span>
                        <span>Pendiente</span>
                        <span>Almacén</span>
                        </div>

                      {Array.isArray(documento.DocumentLines) && documento.DocumentLines.length > 0 ? (
                        documento.DocumentLines.map((linea, lineIndex) => {
                          const isClosed =
                            linea.IsClosedLine || Number(linea.OpenQuantity || 0) <= 0;

                          return (
                            <div
                              key={lineIndex}
                              className={`lines-row ${isClosed ? "lines-row-closed" : ""} ${linea.RutaScanStatus === "valid" ? "ruta-card-valid" : ""}`}
                            >
                              <span className="line-text line-numero mobile-card-no" data-label="No.">
                                {lineIndex + 1}
                              </span>

                              <div className="cell-accion mobile-card-accion" data-label="Acción">
                                <button
                                  type="button"
                                  className="btn-eliminar-linea"
                                  onClick={() => handleEliminarLineaConsolidado(documentoIndex, lineIndex)}
                                >
                                  Eliminar
                                </button>
                              </div>

                              <span
                                className="line-text cell-codigo mobile-card-codigo"
                                data-label="Código"
                                title={obtenerCodigoArticulo(linea) || "-"}
                              >
                                {obtenerCodigoArticulo(linea) || "-"}
                              </span>

                              <span className="line-text cell-descripcion mobile-card-descripcion" data-label="Descripción">
                                {obtenerDescripcionArticulo(linea) || "-"}
                              </span>

                              <span className="line-text mobile-card-ubicacion" data-label="Ubicación">
                                {obtenerUbicacionLinea(linea, tagsPorItemCode) || "-"}
                              </span>

                              <span className="line-text mobile-card-stock" data-label="Stock">
                                {obtenerStockAlmacenOrigen(linea) || "-"}
                              </span>

                              <div className="line-card-input-field mobile-card-cantidad" data-label="Cantidad">
                                <input
                                  className={`line-input ${isClosed ? "line-input-closed" : ""}`}
                                  type="text"
                                  inputMode="decimal"
                                  autoComplete="off"
                                  value={getEditableDecimalValue(linea, "Quantity")}
                                  disabled={isClosed}
                                  onFocus={(e) => e.target.select()}
                                  onChange={(e) => handleLineConsolidadoChange(documentoIndex, lineIndex, "Quantity", e.target.value)}
                                  onBlur={() => handleLineConsolidadoInputBlur(documentoIndex, lineIndex, "Quantity")}
                                />
                              </div>

                              <span className="line-text mobile-card-pendiente" data-label="Pendiente">
                                {formatMoney2(linea.OpenQuantity != null ? linea.OpenQuantity : 0)}
                              </span>

                              <div className="line-card-input-field mobile-card-origen" data-label="Almacén">
                                <input
                                  className="line-input line-input-closed"
                                  type="text"
                                  value={obtenerAlmacenOrigen(linea) || "-"}
                                  disabled
                                  readOnly
                                />
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="lines-row lines-row-empty">
                          <span className="line-text" data-label="Detalle">
                            No hay líneas para mostrar
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="orden-footer-grid consolidado-footer-grid">
                    <div className="form-field form-field-comments">
                      <label className="form-label">Comentario</label>
                      <textarea
                        className="form-textarea"
                        autoComplete="off"
                        autoCorrect="off"
                        value={documento.CommentsBase ?? ""}
                        onChange={(e) => handleCommentsConsolidadoChange(documentoIndex, e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              ))}

              <div className="modal-actions consolidado-actions modal-actions-with-scanner">
                <div className="scanner-action-field">
                  <label className="scanner-action-label">Escanear código</label>
                  <input
                    className="scanner-action-input"
                    type="text"
                    inputMode="text"
                    autoComplete="off"
                    autoCorrect="off"
                    placeholder="Escanee código de ruta o artículo"
                    value={codigosRutaConsolidado[0] || ""}
                    disabled={procesandoConsolidado}
                    onChange={(e) =>
                      registrarLecturaRapidaEscaner({
                        id: "consolidado-0",
                        value: e.target.value,
                        setValue: (nuevoValor) => {
                          setCodigosRutaConsolidado((prev) => ({
                            ...prev,
                            0: nuevoValor,
                          }));
                        },
                        callback: (value) =>
                          handleEscanearRutaConsolidado(0, value, {
                            autoSeleccionarPorAlmacen: true,
                          }),
                      })
                    }
                    onKeyDown={(e) =>
                      manejarConfirmacionEscaneo(
                        e,
                        (value) => handleEscanearRutaConsolidado(0, value),
                        "consolidado-0"
                      )
                    }
                  />
                </div>
                <button
                  type="button"
                  className="btn-secondary"
                  onClick={closeModalConsolidado}
                  disabled={procesandoConsolidado}
                >
                  Cerrar
                </button>
                <button
                  type="button"
                  className="btn-primary"
                  onClick={handleGuardarConsolidado}
                  disabled={procesandoConsolidado}
                >
                  Procesar consolidado
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {modalCancelacionOpen && formDataCancelacion && (
        <div className="modal-overlay" onClick={closeModalCancelacion}>
          <div
            className="modal-content modal-orden-compra"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <div className="modal-header-text">
                <h2>Detalle Entrega</h2>
                <p className="modal-subtitle">
                  DocNum: {formDataCancelacion.DocNum} | Entrega
                </p>
              </div>

              <button className="modal-close-btn" onClick={closeModalCancelacion}>
                ×
              </button>
            </div>

            <div className="modal-body">
              <div className="modal-section">
                <h3 className="modal-section-title">Datos de encabezado</h3>

                <div className="orden-header-grid">
                  <div className="form-field form-field-sm">
                    <label className="form-label"># Documento</label>
                    <div className="form-value form-readonly">
                      {formDataCancelacion.DocNum}
                    </div>
                  </div>


                  <div className="form-field form-field-sm">
                    <label className="form-label">Fecha de Contabilización</label>
                    <input
                      className="form-date"
                      type="date"
                      value={formDataCancelacion.TaxDate}
                      disabled
                      readOnly
                    />
                  </div>

                  <div className="form-field form-field-sm">
                    <label className="form-label">Fecha de Vencimiento</label>
                    <input
                      className="form-date"
                      type="date"
                      value={formDataCancelacion.DocDueDate}
                      disabled
                      readOnly
                    />
                  </div>

                  <div className="form-field form-field-sm">
                    <label className="form-label">Fecha de Documento</label>
                    <input
                      className="form-date"
                      type="date"
                      value={formDataCancelacion.DocDate}
                      disabled
                      readOnly
                    />
                  </div>


                </div>
              </div>

              <div className="modal-section">
                <h3 className="modal-section-title">Líneas de la entrega</h3>

                <div className="lines-table-wrapper lines-card-wrapper">
                  <div className="lines-table lines-card-table">
                    <div className="lines-header">
                      <span className="col-numero-linea">No.</span>
                      <span className="col-accion">Acción</span>
                      <span>Código</span>
                      <span className="col-descripcion">Descripción</span>
                      <span>Ubicación</span>
                      <span>Stock</span>
                      <span>Cantidad</span>
                      <span>Pendiente</span>
                      <span>Almacén</span>
                    </div>

                    {Array.isArray(formDataCancelacion.DocumentLines) &&
                    formDataCancelacion.DocumentLines.length > 0 ? (
                      formDataCancelacion.DocumentLines.map((linea, index) => {
                        return (
                          <div key={index} className={`lines-row ${linea.RutaScanStatus === "valid" ? "ruta-card-valid" : ""}`}>
                            <span
                              className="line-text line-numero mobile-card-no"
                              data-label="No."
                            >
                              {index + 1}
                            </span>

                            <div
                              className="cell-accion mobile-card-accion"
                              data-label="Acción"
                            >
                              <span className="line-text">-</span>
                            </div>

                            <span
                              className="line-text cell-codigo mobile-card-codigo"
                              data-label="Código"
                              title={obtenerCodigoArticulo(linea) || "-"}
                            >
                              {obtenerCodigoArticulo(linea) || "-"}
                            </span>

                            <span
                              className="line-text cell-descripcion mobile-card-descripcion"
                              data-label="Descripción"
                            >
                              {obtenerDescripcionArticulo(linea) || "-"}
                            </span>

                            <span
                              className="line-text mobile-card-ubicacion"
                              data-label="Ubicación"
                            >
                              {obtenerUbicacionLinea(linea, tagsPorItemCode) || "-"}
                            </span>

                            <span
                              className="line-text mobile-card-stock"
                              data-label="Stock"
                            >
                              {obtenerStockAlmacenOrigen(linea) || "-"}
                            </span>

                            <div
                              className="line-card-input-field mobile-card-cantidad"
                              data-label="Cantidad"
                            >
                              <input
                                className="line-input line-input-closed"
                                type="text"
                                value={formatMoney2(linea.Quantity || 0)}
                                disabled
                                readOnly
                              />
                            </div>

                            <span
                              className="line-text mobile-card-pendiente"
                              data-label="Pendiente"
                            >
                              {formatMoney2(
                                linea.OpenQuantity != null
                                  ? linea.OpenQuantity
                                  : linea.Quantity || 0
                              )}
                            </span>

                            <div
                              className="line-card-input-field mobile-card-origen"
                              data-label="Almacen Origen"
                            >
                              <input
                                className="line-input line-input-closed"
                                type="text"
                                value={obtenerAlmacenOrigen(linea) || "-"}
                                disabled
                                readOnly
                              />
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="lines-row lines-row-empty">
                        <span className="line-text" data-label="Detalle">
                          No hay líneas para mostrar
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="modal-section">
                <div className="orden-footer-grid">
                  <div className="form-field form-field-comments">
                    <label className="form-label">Comentario</label>
                    <textarea
                      className="form-textarea"
                      autoComplete="off"
                      autoCorrect="off"
                      value={comentarioCompletoCancelacion}
                      onChange={(e) =>
                        handleCommentsCancelacionChange(e.target.value)
                      }
                    />
                  </div>

                </div>
              </div>

              <div className="modal-actions modal-actions-with-scanner">
                <div className="scanner-action-field">
                  <label className="scanner-action-label">Escanear código</label>
                  <input
                    className="scanner-action-input"
                    type="text"
                    inputMode="text"
                    autoComplete="off"
                    autoCorrect="off"
                    placeholder="Escanee código de ruta o artículo"
                    value={codigoRutaCancelacion}
                    onChange={(e) =>
                      registrarLecturaRapidaEscaner({
                        id: "cancelacion",
                        value: e.target.value,
                        setValue: setCodigoRutaCancelacion,
                        callback: (value) =>
                          handleEscanearRutaDocumento(value, "cancelacion", {
                            autoSeleccionarPorAlmacen: true,
                          }),
                      })
                    }
                    onKeyDown={(e) =>
                      manejarConfirmacionEscaneo(
                        e,
                        (value) => handleEscanearRutaDocumento(value, "cancelacion"),
                        "cancelacion"
                      )
                    }
                  />
                </div>
                <button
                  type="button"
                  className="btn-secondary"
                  onClick={closeModalCancelacion}
                >
                  Cerrar
                </button>
                <button
                  type="button"
                  className="btn-primary"
                  onClick={handleCancelarEntregaStock}
                >
                  Cancelar Entrega
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


      {mobileKeyboardButton.visible && (
        <button
          type="button"
          className="btn-open-mobile-keyboard"
          style={{
            position: "fixed",
            top: `${mobileKeyboardButton.top}px`,
            left: `${mobileKeyboardButton.left}px`,
            width: "40px",
            height: "36px",
            border: "none",
            borderRadius: "8px",
            background: "#0f172a",
            color: "#ffffff",
            fontSize: "18px",
            fontWeight: 700,
            zIndex: 1000002,
            boxShadow: "0 10px 24px rgba(15, 23, 42, 0.28)",
            cursor: "pointer",
          }}
          tabIndex={-1}
          onMouseDown={abrirTecladoManual}
          onTouchStart={abrirTecladoManual}
          onPointerDown={abrirTecladoManual}
          onClick={abrirTecladoManual}
          aria-label="Abrir teclado"
          title="Abrir teclado"
        >
          ⌨
        </button>
      )}

    </div>
  );
};

export default Entregas;